<template>
  <div id="content">
    <div class="popupemail" v-if="openRegule">
      <div class="popup-edit-email">
        <div class="step-contenair">
          <div class="elem">
            <label>Nom &nbsp;</label>
            <input
              type="text"
              v-model="regule.last_name"
              placeholder="Ex : Dupont"
            />
          </div>

          <div class="elem">
            <label>Prénom &nbsp;</label>
            <input
              type="text"
              v-model="regule.first_name"
              placeholder="Ex : Monique"
            />
          </div>

          <div class="elem">
            <label>Email </label>
            <input
              type="email"
              v-model="regule.email"
              placeholder="Ex : monique@promo.dev"
            />
          </div>

          <div class="elem">
            <label>IBAN &nbsp;</label>
            <input
              type="text"
              v-model="regule.iban"
              placeholder="Ex : FR7630001007941234567890185"
            />
          </div>

          <div class="elem">
            <label>Montant (centimes) &nbsp;</label>
            <input
              type="number"
              v-model="regule.amount_to_refund"
              placeholder="Ex : 1500"
            />
          </div>

          <div class="elem" style="width:100%">
            <label>Comment &nbsp;</label>
            <textarea
              style="width:100%; height:150px"
              v-model="regule.validation_comment"
            ></textarea>
          </div>

          <div>
            <button
              style="margin-top:10px;"
              class="btn-blue"
              type="button"
              v-on:click="saveSubmission()"
            >
              <i class="fa fa-save"></i> Sauvegarder
            </button>
            &nbsp;&nbsp;

            <button
              style="margin-top:10px; right:10px; bottom:55px;"
              class="btn-blue"
              type="button"
              v-on:click="openRegule = false"
            >
              <i class="fa fa-close"></i> Fermer
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="popupemail" v-if="openmail">
      <div class="popup-edit-email">
        <div>
          Envoyer un test à
          <input
            type="text"
            placeholder="Email Destinataire"
            v-model="destinataire"
            style="width:250px"
          />
          &nbsp;<button class="btn-blue" @click="sendMail">Envoi</button>
          <br /><br />
          TYPE : &nbsp;
          <select
            v-model="emailType"
            style="width:200px"
            @change="changeTemplate"
          >
            <option value=""></option>
            <option value="GAGNE">GAGNE</option>
            <option value="PERD">PERD</option>
            <option value="PENDING">PENDING</option>
            <option value="VALID">VALID</option>
            <option value="REFUND_DONE">REFUND_DONE</option>
            <option value="MISSING">MISSING</option>
            <option value="INVALID">INVALID</option>
          </select>
        </div>
        <i
          v-if="!emailView"
          @click="emailView = true"
          class="fas fa-solid fa-code edithtml"
          style="top:80px;"
        ></i>
        <i
          v-else
          @click="emailView = false"
          class="fas fa-eye-slash edithtml"
          style="top:80px;"
        ></i>
        <div class="popup-edit-wrapper">
          <!-- <p>
            Header : &nbsp;&nbsp;
            <a @click="getMailHeader('logo')">Logo</a
            >
            &nbsp;&nbsp;
            <a @click="getMailHeader('banniere')">Banniére</a
            >
          </p> -->
          <quill-editor
            v-if="!emailView"
            ref="myQuillEditor"
            v-model="emailcontent"
            :options="editorOption"
          />
          <prism-editor
            style="width:95%; height:380px"
            v-if="emailView"
            class="my-editor"
            :line-numbers="true"
            :highlight="highlighter"
            v-model="emailcontent"
          ></prism-editor>

          <div>
            <button
              style="margin-top:10px;"
              class="btn-blue"
              type="button"
              v-on:click="saveEmails()"
            >
              <i class="fa fa-save"></i> Sauvegarder
            </button>
            &nbsp;&nbsp;

            <button
              style="margin-top:10px; right:10px; bottom:55px;"
              class="btn-blue"
              type="button"
              v-on:click="openmail = false"
            >
              <i class="fa fa-close"></i> Fermer
            </button>
          </div>
        </div>
      </div>
    </div>

    <sweet-modal ref="modal" title="Preview">
      <div>
        <iframe
          v-if="formId"
          :src="`https://lucien-test-builder.netlify.app/form/${formId}`"
        ></iframe>
      </div>
    </sweet-modal>

    <div class="contenair bg-gradient">
      <h1 class="title">
        &nbsp;<i class="fa fa-file-text-o" aria-hidden="true"></i>&nbsp;
        {{ form.title }}
      </h1>

      <br />
      <MenuOperation
        :id="$route.params._id"
        :type="form.type"
      />

      <div class="form-container-step">
        <form>
          <div class="step-contenair" v-if="step == 6">
            <vue-tabs
              active-tab-color="#e74c3c"
              active-text-color="white"
              style="margin-top:15px"
            >
              <v-tab icon="ti-user" title="Menu">
                <div class="step-contenair">
                  <div style="width:100%;">
                    <h3 class="customtitle">
                      Menu / Navigation
                      <i class="fas fa-question-circle" aria-hidden="true"></i
                      ><i
                        v-on:click="nextStep()"
                        class="fas fa-save savestep"
                      ></i>
                    </h3>
                  </div>
                  <div class="elem">
                    <label
                      >Opacité de la barre de navigation &nbsp;(
                      {{ custom.transparence_nav_link }}% )</label
                    >
                    <input
                      v-model="custom.transparence_nav_link"
                      name="transparence_nav_link"
                      id="transparence_nav_link"
                      type="range"
                    />
                  </div>

                  <div class="elem">
                    <label for="banner_disable_animation"
                      >Position du Menu Mobile & Tablette</label
                    >

                    <div class="menumobilecustom">
                      <div>
                        <input
                          type="radio"
                          id="menuleft"
                          value="left"
                          v-model="custom.mobile_menu_position"
                        />
                        <label for="menuleft">Gauche</label>
                      </div>
                      <div>
                        <input
                          type="radio"
                          id="menudroite"
                          value="right"
                          v-model="custom.mobile_menu_position"
                        />
                        <label for="menudroite">Droite</label>
                      </div>
                    </div>
                  </div>

                  <div class="elem">
                    <div class="colorfill">
                      <div
                        class="pickerview"
                        :style="`background-color:${custom.color_top_link}`"
                      >
                        <verte
                          picker="wheel"
                          model="hex"
                          v-model="custom.color_top_link"
                        >
                        </verte>
                      </div>
                      <label for="color_top_link"
                        >Couleur des liens de navigation
                      </label>
                    </div>
                  </div>

                  <div class="elem">
                    <div class="colorfill">
                      <div
                        class="pickerview"
                        :style="`background-color:${custom.color_top_bg_link}`"
                      >
                        <verte
                          model="hex"
                          picker="wheel"
                          v-model="custom.color_top_bg_link"
                        >
                        </verte>
                      </div>
                      <label for="color_top_bg_link"
                        >Couleur de la barre de menu
                      </label>
                    </div>
                  </div>

                  <div style="width:100%;">
                    <h3 class="customtitle">
                      Gestion des liens externes
                      <i
                        v-on:click="nextStep()"
                        class="fas fa-save savestep"
                      ></i>
                    </h3>
                  </div>

                  <div
                    style="display:flex !important;width:100% !important;"
                    v-for="(item, index) in custom.links"
                    v-bind:key="index"
                  >
                    <div class="elem">
                      <label>Label Lien {{ index + 1 }}</label>
                      <input
                        type="text"
                        :name="`custom.label${index + 1}`"
                        :id="`custom.label${index + 1}`"
                        v-model="item.label"
                        placeholder="Nom du lien"
                      />
                    </div>

                    <div class="elem">
                      <label
                        >URL Lien {{ index + 1 }} &nbsp;&nbsp;<a
                          :href="`${item.link}`"
                          v-if="item.link"
                          targer="_blank"
                          ><i class="fas fa-eye"></i></a
                      ></label>
                      <input
                        style="width:65%"
                        pattern="https?://.+"
                        type="text"
                        :name="`custom.link${index + 1}`"
                        :id="`custom.link${index + 1}`"
                        v-model="item.link"
                        placeholder="https://"
                      />
                      <select v-model="item.target" style="width:24%">
                        <option>_blank</option>
                        <option>_self</option>
                        <option>_parent</option>
                        <option>_top</option>
                      </select>
                    </div>
                  </div>

                  <div class="elem">
                    <label
                      >politique de confidentialité (pdf, doc, docx)<span
                        v-if="ifUploaded('politique')"
                        >&nbsp;&nbsp;<a
                          :href="ifUploaded('politique')"
                          targer="_blank"
                          ><i class="fas fa-eye"></i
                        ></a>
                        &nbsp;<i
                          v-on:click="deleteFile('politique')"
                          class="fa fa-trash"
                          aria-hidden="true"
                        ></i></span
                    ></label>
                    <div class="upload-btn-wrapper2">
                      <button class="btn2">
                        <i aria-hidden="true" class="fa fa-cloud-upload"></i>
                        Uploader la politique de confidentialité
                      </button>
                      <input
                        type="file"
                        name="myfile"
                        id="file"
                        ref="politique"
                        :accept="
                          ['politique'].includes('politique')
                            ? '.pdf, .doc, .docx'
                            : '.png,.mp4,.jpg,.ico'
                        "
                        v-on:change="singleUpload('politique')"
                      />
                    </div>
                  </div>

                  <div class="elem">
                    <label
                      >réglement (pdf, doc , docx)&nbsp;&nbsp;<span
                        v-if="ifUploaded('reglement')"
                        ><a :href="ifUploaded('reglement')" targer="_blank"
                          ><i class="fas fa-eye"></i></a
                        >&nbsp;<i
                          v-on:click="deleteFile('reglement')"
                          class="fa fa-trash"
                          aria-hidden="true"
                        ></i></span
                    ></label>
                    <div class="upload-btn-wrapper2">
                      <button class="btn2">
                        <i aria-hidden="true" class="fa fa-cloud-upload"></i>
                        Uploader le réglement
                      </button>
                      <input
                        type="file"
                        name="myfile"
                        id="file"
                        ref="reglement"
                        :accept="
                          ['reglement'].includes('reglement')
                            ? '.pdf, .doc, .docx'
                            : '.png,.mp4,.jpg,.ico'
                        "
                        v-on:change="singleUpload('reglement')"
                      />
                    </div>
                  </div>

                  <div class="elem">
                    <label
                      >modalités (pdf)&nbsp;&nbsp;<span
                        v-if="ifUploaded('modalites')"
                        ><a :href="ifUploaded('modalites')" targer="_blank"
                          ><i class="fas fa-eye"></i></a
                        >&nbsp;<i
                          v-on:click="deleteFile('modalites')"
                          class="fa fa-trash"
                          aria-hidden="true"
                        ></i></span
                    ></label>
                    <div class="upload-btn-wrapper2">
                      <button class="btn2">
                        <i aria-hidden="true" class="fa fa-cloud-upload"></i>
                        Uploader les modalités
                      </button>
                      <input
                        type="file"
                        name="myfile"
                        id="file"
                        ref="modalites"
                        :accept="
                          ['modalites'].includes('modalites')
                            ? '.pdf, .doc, .docx'
                            : '.png,.mp4,.jpg,.ico'
                        "
                        v-on:change="singleUpload('modalites')"
                      />
                    </div>
                  </div>

                  <div style="width:100%;">
                    <h3 class="customtitle">
                      Gestion des réseaux sociaux<i
                        v-on:click="nextStep()"
                        class="fas fa-save savestep"
                      ></i>
                    </h3>
                  </div>

                  <div class="elem">
                    <label
                      ><i class="fab fa-facebook-square"></i> Facebook &nbsp;<a
                        :href="`${custom.facebook_link}`"
                        style="color:#444"
                        v-if="custom.facebook_link"
                        target="_blank"
                        ><i class="fas fa-eye"></i></a
                    ></label>
                    <input
                      type="text"
                      v-model="custom.facebook_link"
                      placeholder="https://"
                    />
                  </div>

                  <div class="elem">
                    <label
                      ><i class="fab fa-twitter"></i> Twitter &nbsp;<a
                        :href="`${custom.twitter_link}`"
                        style="color:#444"
                        v-if="custom.twitter_link"
                        target="_blank"
                        ><i class="fas fa-eye"></i></a
                    ></label>
                    <input
                      type="text"
                      v-model="custom.twitter_link"
                      placeholder="https://"
                    />
                  </div>

                  <div class="elem">
                    <label
                      ><i class="fab fa-discord"></i> Discord&nbsp;<a
                        :href="`${custom.discord_link}`"
                        style="color:#444"
                        v-if="custom.discord_link"
                        target="_blank"
                        ><i class="fas fa-eye"></i></a
                    ></label>
                    <input
                      type="text"
                      v-model="custom.discord_link"
                      placeholder="https://"
                    />
                  </div>

                  <div class="elem">
                    <label
                      ><i class="fab fa-instagram"></i> Instagram &nbsp;<a
                        :href="`${custom.instagram_link}`"
                        style="color:#444"
                        v-if="custom.instagram_link"
                        target="_blank"
                        ><i class="fas fa-eye"></i></a
                    ></label>
                    <input
                      type="text"
                      v-model="custom.instagram_link"
                      placeholder="https://"
                    />
                  </div>

                  <div class="elem">
                    <label
                      ><i class="fab fa-youtube"></i> Youtube &nbsp;<a
                        :href="`${custom.youtube_link}`"
                        style="color:#444"
                        v-if="custom.youtube_link"
                        target="_blank"
                        ><i class="fas fa-eye"></i></a
                    ></label>
                    <input
                      type="text"
                      v-model="custom.youtube_link"
                      placeholder="https://"
                    />
                  </div>

                  <div class="elem">
                    <label
                      ><i class="fab fa-snapchat-ghost"></i> &nbsp;Snapchat
                      &nbsp;<a
                        :href="`${custom.snapchat_link}`"
                        style="color:#444"
                        v-if="custom.snapchat_link"
                        target="_blank"
                        ><i class="fas fa-eye"></i></a
                    ></label>
                    <input
                      type="text"
                      v-model="custom.snapchat_link"
                      placeholder="https://"
                    />
                  </div>

                  <div class="elem">
                    <label
                      ><i class="fab fa-linkedin"></i> &nbsp;Linkedin &nbsp;<a
                        :href="`${custom.linkedin_link}`"
                        style="color:#444"
                        target="_blank"
                        v-if="custom.linkedin_link"
                        ><i class="fas fa-eye"></i></a
                    ></label>
                    <input
                      type="text"
                      v-model="custom.linkedin_link"
                      placeholder="https://"
                    />
                  </div>

                  <div class="elem">
                    <label
                      ><i class="fab fa-pinterest-square"></i> &nbsp;Pinterest
                      &nbsp;<a
                        :href="`${custom.pinterest_link}`"
                        style="color:#444"
                        target="_blank"
                        v-if="custom.pinterest_link"
                        ><i class="fas fa-eye"></i></a
                    ></label>
                    <input
                      type="text"
                      v-model="custom.pinterest_link"
                      placeholder="https://"
                    />
                  </div>

                  <div class="elem">
                    <label
                      ><i class="fab fa-tiktok"></i> &nbsp;TikTok &nbsp;<a
                        :href="`${custom.tiktok_link}`"
                        style="color:#444"
                        target="_blank"
                        v-if="custom.tiktok_link"
                        ><i class="fas fa-eye"></i></a
                    ></label>
                    <input
                      type="text"
                      v-model="custom.tiktok_link"
                      placeholder="https://"
                    />
                  </div>
                </div>
              </v-tab>

              <v-tab title="Accueil">
                <div class="step-contenair">
                  <div style="width:100%;">
                    <h3 class="customtitle">
                      Textes sur la page d'acceuil (Homepage)
                      <i
                        v-on:click="nextStep()"
                        class="fas fa-save savestep"
                      ></i>
                    </h3>
                  </div>
                  <div class="elem" style="width:100%">
                    <label>Titre </label>
                    <i
                      v-if="!htmlview[0]"
                      @click="toogleViewcode(0)"
                      class="fas fa-solid fa-code edithtml"
                    ></i>
                    <i
                      v-else
                      @click="toogleViewcode(0)"
                      class="fas fa-eye-slash edithtml"
                    ></i>
                    <quill-editor
                      v-if="!htmlview[0]"
                      class="editgab"
                      style="width:100%; height:150px"
                      ref="myQuillEditor"
                      v-model="custom.titre_home"
                      :options="editorOptionGabarit"
                    />
                    <prism-editor
                      v-if="htmlview[0]"
                      style="width:95%; height:170px"
                      class="my-editor"
                      :line-numbers="true"
                      :highlight="highlighter"
                      v-model="custom.titre_home"
                    ></prism-editor>
                  </div>

                  <div class="elem" style="width:100%;">
                    <label>Texte d'accueil </label>
                    <i
                      v-if="!htmlview[1]"
                      @click="toogleViewcode(1)"
                      class="fas fa-solid fa-code edithtml"
                    ></i>
                    <i
                      v-else
                      @click="toogleViewcode(1)"
                      class="fas fa-eye-slash edithtml"
                    ></i>
                    <quill-editor
                      v-if="!htmlview[1]"
                      class="editgab"
                      style="width:100%; height:150px"
                      ref="myQuillEditor"
                      v-model="custom.text_home"
                      :options="editorOptionGabarit"
                    />
                    <prism-editor
                      v-if="htmlview[1]"
                      style="width:95%; height:170px"
                      class="my-editor"
                      :line-numbers="true"
                      :highlight="highlighter"
                      v-model="custom.text_home"
                    ></prism-editor>
                  </div>

                  <div class="elem">
                    <label>TEXTE DU BOUTON D'ACTION</label>
                    <input
                      type="text"
                      v-model="custom.home_btn_txt"
                      name="home_btn_txt"
                      id="home_btn_txt"
                      data-vv-scope="step6"
                      placeholder="Ex: PARTICIPER"
                    />
                  </div>

                  <h3 class="customtitle">
                    Cookies Bar
                    <i v-on:click="nextStep()" class="fas fa-save savestep"></i>
                  </h3>

                  <div class="elem">
                    <label for="banner_disable_cookie"
                      >Affichage de la cookies bar</label
                    >

                    <div class="menumobilecustom">
                      <div>
                        <input
                          type="radio"
                          id="cclawoff"
                          value="false"
                          v-model="custom.banner_disable_cookie"
                        />
                        <label for="cclawoff">Activer</label>
                      </div>
                      <div>
                        <input
                          type="radio"
                          id="cclawon"
                          value="true"
                          v-model="custom.banner_disable_cookie"
                        />
                        <label for="cclawon">Desactiver</label>
                      </div>
                    </div>
                  </div>

                  <h3 class="customtitle">
                    Textes avant et après opération
                    <i v-on:click="nextStep()" class="fas fa-save savestep"></i>
                  </h3>

                  <div class="elem" style="width:100%">
                    <label
                      >Texte avant opération &nbsp;<i
                        class="fas fa-question-circle"
                      ></i
                    ></label>
                    <i
                      v-if="!htmlview[2]"
                      @click="toogleViewcode(2)"
                      class="fas fa-solid fa-code edithtml"
                    ></i>
                    <i
                      v-else
                      @click="toogleViewcode(2)"
                      class="fas fa-eye-slash edithtml"
                    ></i>
                    <quill-editor
                      v-if="!htmlview[2]"
                      class="editgab"
                      style="width:100%; height:150px"
                      ref="myQuillEditor"
                      v-model="custom.text_wait"
                      :options="editorOptionGabarit"
                    />
                    <prism-editor
                      v-if="htmlview[2]"
                      style="width:95%; height:170px"
                      class="my-editor"
                      :line-numbers="true"
                      :highlight="highlighter"
                      v-model="custom.text_wait"
                    ></prism-editor>
                  </div>

                  <div class="elem" style="width:100%">
                    <label>Texte opération terminé </label>
                    <i
                      v-if="!htmlview[3]"
                      @click="toogleViewcode(3)"
                      class="fas fa-solid fa-code edithtml"
                    ></i>
                    <i
                      v-else
                      @click="toogleViewcode(3)"
                      class="fas fa-eye-slash edithtml"
                    ></i>
                    <quill-editor
                      v-if="!htmlview[3]"
                      class="editgab"
                      style="width:100%; height:150px"
                      ref="myQuillEditor"
                      v-model="custom.text_finish"
                      :options="editorOptionGabarit"
                    />
                    <prism-editor
                      v-if="htmlview[3]"
                      style="width:95%; height:170px"
                      class="my-editor"
                      :line-numbers="true"
                      :highlight="highlighter"
                      v-model="custom.text_finish"
                    ></prism-editor>
                  </div>
                </div>
              </v-tab>

              <v-tab title="Formulaire">
                <div class="step-contenair">
                  <div style="width:100%;">
                    <h3 class="customtitle">
                      Couleurs du formulaire<i
                        v-on:click="nextStep()"
                        class="fas fa-save savestep"
                      ></i>
                    </h3>
                  </div>
                  <div class="elem">
                    <div class="colorfill">
                      <div
                        class="pickerview"
                        :style="`background-color:${custom.color_input_border}`"
                      >
                        <verte
                          model="hex"
                          picker="wheel"
                          v-model="custom.color_input_border"
                        >
                        </verte>
                      </div>
                      <label for="color_input_border"
                        >Couleur de la bordure des champs
                      </label>
                    </div>
                  </div>

                  <div class="elem">
                    <div class="colorfill">
                      <div
                        class="pickerview"
                        :style="`background-color:${custom.color_input_bg}`"
                      >
                        <verte
                          model="hex"
                          picker="wheel"
                          v-model="custom.color_input_bg"
                        >
                        </verte>
                      </div>
                      <label for="color_input_bg"
                        >Couleur de fond des champs
                      </label>
                    </div>
                  </div>

                  <div class="elem">
                    <div class="colorfill">
                      <div
                        class="pickerview"
                        :style="`background-color:${custom.color_input_txt}`"
                      >
                        <verte
                          model="hex"
                          picker="wheel"
                          v-model="custom.color_input_txt"
                        >
                        </verte>
                      </div>
                      <label for="color_input_txt"
                        >Couleur des textes dans les champs
                      </label>
                    </div>
                  </div>

                  <div class="elem">
                    <div class="colorfill">
                      <div
                        class="pickerview"
                        :style="
                          `background-color:${custom.color_input_bg_focus}`
                        "
                      >
                        <verte
                          model="hex"
                          picker="wheel"
                          v-model="custom.color_input_bg_focus"
                        >
                        </verte>
                      </div>
                      <label for="color_input_bg_focus"
                        >Couleur du champ séléctionné (focus)
                      </label>
                    </div>
                  </div>

                  <div class="elem">
                    <div class="colorfill">
                      <div
                        class="pickerview"
                        :style="
                          `background-color:${custom.color_input_bg_error}`
                        "
                      >
                        <verte
                          model="hex"
                          picker="wheel"
                          v-model="custom.color_input_bg_error"
                        >
                        </verte>
                      </div>
                      <label for="color_input_bg_error"
                        >Couleur d'un champ en erreur
                      </label>
                    </div>
                  </div>

                  <div class="elem">
                    <div class="colorfill">
                      <div
                        class="pickerview"
                        :style="`background-color:${custom.color_error_txt}`"
                      >
                        <verte
                          model="hex"
                          picker="wheel"
                          v-model="custom.color_error_txt"
                        >
                        </verte>
                      </div>
                      <label for="color_error_txt"
                        >Couleur des textes d'erreur
                      </label>
                    </div>
                  </div>

                  <div class="elem">
                    <div class="colorfill">
                      <div
                        class="pickerview"
                        :style="
                          `background-color:${custom.color_bg_button_back}`
                        "
                      >
                        <verte
                          model="hex"
                          picker="wheel"
                          v-model="custom.color_bg_button_back"
                        >
                        </verte>
                      </div>
                      <label for="color_bg_button_back"
                        >Couleur de fond du bouton retour
                      </label>
                    </div>
                  </div>

                  <div class="elem">
                    <div class="colorfill">
                      <div
                        class="pickerview"
                        :style="
                          `background-color:${custom.color_text_button_back}`
                        "
                      >
                        <verte
                          model="hex"
                          picker="wheel"
                          v-model="custom.color_text_button_back"
                        >
                        </verte>
                      </div>
                      <label for="color_text_button_back"
                        >Couleur du texte du bouton retour
                      </label>
                    </div>
                  </div>
                  <div style="width:100%;">
                    <h3 class="customtitle">
                      Style<i
                        v-on:click="nextStep()"
                        class="fas fa-save savestep"
                      ></i>
                    </h3>
                  </div>
                  <div class="elem">
                    <label>Arrondi des champs (px)</label>
                    <input
                      type="number"
                      v-model="custom.border_radius_field"
                      name="border_radius_field"
                      id="border_radius_field"
                      data-vv-scope="step6"
                      placeholder="Ex: 3"
                    />
                  </div>

                  <div style="width:100%;">
                    <h3 class="customtitle">
                      Bannières par étape (facultatif)<i
                        v-on:click="nextStep()"
                        class="fas fa-save savestep"
                      ></i>
                    </h3>
                  </div>

                  <div class="elem">
                    <label
                      >Bannière étape 1&nbsp;&nbsp;<span
                        v-if="ifUploaded('banner_mb_step1')"
                        ><a
                          :href="ifUploaded('banner_mb_step1')"
                          targer="_blank"
                          ><i class="fas fa-eye"></i
                        ></a>
                        &nbsp;<i
                          v-on:click="deleteFile('banner_mb_step1')"
                          class="fa fa-trash"
                          aria-hidden="true"
                        ></i></span
                    ></label>
                    <div class="upload-btn-wrapper2">
                      <button class="btn2">
                        <i aria-hidden="true" class="fa fa-cloud-upload"></i>
                        Uploader
                      </button>
                      <input
                        type="file"
                        name="myfile"
                        id="file"
                        ref="banner_mb_step1"
                        :accept="
                          ['banner_mb_step1'].includes('banner_mb_step1')
                            ? '.jpeg, .jpg, .gif, .png'
                            : '.png,.mp4,.jpg,.ico'
                        "
                        v-on:change="singleUpload('banner_mb_step1')"
                      />
                    </div>
                    <span class="infosupup"
                      >(800x800 au format jpg, jpeg, png, gif)</span
                    >
                  </div>

                  <div class="elem">
                    <label
                      >Bannière étape 2&nbsp;&nbsp;<span
                        v-if="ifUploaded('banner_mb_step2')"
                        ><a
                          :href="ifUploaded('banner_mb_step2')"
                          targer="_blank"
                          ><i class="fas fa-eye"></i
                        ></a>
                        &nbsp;<i
                          v-on:click="deleteFile('banner_mb_step2')"
                          class="fa fa-trash"
                          aria-hidden="true"
                        ></i></span
                    ></label>
                    <div class="upload-btn-wrapper2">
                      <button class="btn2">
                        <i aria-hidden="true" class="fa fa-cloud-upload"></i>
                        Uploader
                      </button>
                      <input
                        type="file"
                        name="myfile"
                        id="file"
                        ref="banner_mb_step2"
                        :accept="
                          ['banner_mb_step2'].includes('banner_mb_step2')
                            ? '.jpeg, .jpg, .gif, .png'
                            : '.png,.mp4,.jpg,.ico'
                        "
                        v-on:change="singleUpload('banner_mb_step2')"
                      />
                    </div>
                    <span class="infosupup"
                      >(800x800 au format jpg, jpeg, png, gif)</span
                    >
                  </div>

                  <div class="elem">
                    <label
                      >Bannière étape 3&nbsp;&nbsp;<span
                        v-if="ifUploaded('banner_mb_step3')"
                        ><a
                          :href="ifUploaded('banner_mb_step3')"
                          targer="_blank"
                          ><i class="fas fa-eye"></i
                        ></a>
                        &nbsp;<i
                          v-on:click="deleteFile('banner_mb_step3')"
                          class="fa fa-trash"
                          aria-hidden="true"
                        ></i></span
                    ></label>
                    <div class="upload-btn-wrapper2">
                      <button class="btn2">
                        <i aria-hidden="true" class="fa fa-cloud-upload"></i>
                        Uploader
                      </button>
                      <input
                        type="file"
                        name="myfile"
                        id="file"
                        ref="banner_mb_step3"
                        :accept="
                          ['banner_mb_step3'].includes('banner_mb_step3')
                            ? '.jpeg, .jpg, .gif, .png'
                            : '.png,.mp4,.jpg,.ico'
                        "
                        v-on:change="singleUpload('banner_mb_step3')"
                      />
                    </div>
                    <span class="infosupup"
                      >(800x800 au format jpg, jpeg, png, gif)</span
                    >
                  </div>

                  <div class="elem">
                    <label
                      >Bannière étape 4&nbsp;&nbsp;<span
                        v-if="ifUploaded('banner_mb_step4')"
                        ><a
                          :href="ifUploaded('banner_mb_step4')"
                          targer="_blank"
                          ><i class="fas fa-eye"></i
                        ></a>
                        &nbsp;<i
                          v-on:click="deleteFile('banner_mb_step4')"
                          class="fa fa-trash"
                          aria-hidden="true"
                        ></i></span
                    ></label>
                    <div class="upload-btn-wrapper2">
                      <button class="btn2">
                        <i aria-hidden="true" class="fa fa-cloud-upload"></i>
                        Uploader
                      </button>
                      <input
                        type="file"
                        name="myfile"
                        id="file"
                        ref="banner_mb_step4"
                        :accept="
                          ['banner_mb_step4'].includes('banner_mb_step4')
                            ? '.jpeg, .jpg, .gif, .png'
                            : '.png,.mp4,.jpg,.ico'
                        "
                        v-on:change="singleUpload('banner_mb_step4')"
                      />
                    </div>
                    <span class="infosupup"
                      >(800x800 au format jpg, jpeg, png, gif)</span
                    >
                  </div>

                  <div class="elem">
                    <label
                      >Bannière étape 5&nbsp;&nbsp;<span
                        v-if="ifUploaded('banner_mb_step5')"
                        ><a
                          :href="ifUploaded('banner_mb_step5')"
                          targer="_blank"
                          ><i class="fas fa-eye"></i
                        ></a>
                        &nbsp;<i
                          v-on:click="deleteFile('banner_mb_step5')"
                          class="fa fa-trash"
                          aria-hidden="true"
                        ></i></span
                    ></label>
                    <div class="upload-btn-wrapper2">
                      <button class="btn2">
                        <i aria-hidden="true" class="fa fa-cloud-upload"></i>
                        Uploader
                      </button>
                      <input
                        type="file"
                        name="myfile"
                        id="file"
                        ref="banner_mb_step5"
                        :accept="
                          ['banner_mb_step5'].includes('banner_mb_step5')
                            ? '.jpeg, .jpg, .gif, .png'
                            : '.png,.mp4,.jpg,.ico'
                        "
                        v-on:change="singleUpload('banner_mb_step5')"
                      />
                    </div>
                    <span class="infosupup"
                      >(800x800 au format jpg, jpeg, png, gif)</span
                    >
                  </div>

                  <div class="elem">
                    <label
                      >Bannière étape 6&nbsp;&nbsp;<span
                        v-if="ifUploaded('banner_mb_step6')"
                        ><a
                          :href="ifUploaded('banner_mb_step6')"
                          targer="_blank"
                          ><i class="fas fa-eye"></i
                        ></a>
                        &nbsp;<i
                          v-on:click="deleteFile('banner_mb_step6')"
                          class="fa fa-trash"
                          aria-hidden="true"
                        ></i></span
                    ></label>
                    <div class="upload-btn-wrapper2">
                      <button class="btn2">
                        <i aria-hidden="true" class="fa fa-cloud-upload"></i>
                        Uploader
                      </button>
                      <input
                        type="file"
                        name="myfile"
                        id="file"
                        ref="banner_mb_step6"
                        :accept="
                          ['banner_mb_step6'].includes('banner_mb_step6')
                            ? '.jpeg, .jpg, .gif, .png'
                            : '.png,.mp4,.jpg,.ico'
                        "
                        v-on:change="singleUpload('banner_mb_step6')"
                      />
                    </div>
                    <span class="infosupup"
                      >(800x800 au format jpg, jpeg, png, gif)</span
                    >
                  </div>
                </div>
              </v-tab>

              <v-tab title="Page de confirmation">
                <div class="step-contenair">
                  <div style="width:100%;" v-if="form.type === 'ODR' || form.type === 'FORMULAIRE'">
                    <h3 class="customtitle">
                      Texte de la page confirmation de participation
                      <i
                        v-on:click="nextStep()"
                        class="fas fa-save savestep"
                      ></i>
                    </h3>
                  </div>
                  <div
                    class="elem"
                    style="width:100%"
                    v-if="form.type === 'ODR' || form.type === 'FORMULAIRE'"
                  >
                    <label>Titre </label>
                    <i
                      v-if="!htmlview[4]"
                      @click="toogleViewcode(4)"
                      class="fas fa-solid fa-code edithtml"
                    ></i>
                    <i
                      v-else
                      @click="toogleViewcode(4)"
                      class="fas fa-eye-slash edithtml"
                    ></i>
                    <quill-editor
                      v-if="!htmlview[4]"
                      class="editgab"
                      style="width:100%; height:150px"
                      ref="myQuillEditor"
                      v-model="custom.text_submited"
                      :options="editorOptionGabarit"
                    />
                    <prism-editor
                      v-if="htmlview[4]"
                      style="width:95%; height:170px"
                      class="my-editor"
                      :line-numbers="true"
                      :highlight="highlighter"
                      v-model="custom.text_submited"
                    ></prism-editor>
                  </div>

                  <h3 class="customtitle" v-if="form.type === 'JEU WEB'">
                    Texte de confirmation (Consolante)
                    <i v-on:click="nextStep()" class="fas fa-save savestep"></i>
                  </h3>

                  <div class="elem" v-if="form.type === 'JEU WEB'">
                    <label>LIBELLÉ</label>
                    <input
                      type="text"
                      v-model="custom.lotperdu_libelle"
                      name="lotperdu_libelle"
                      id="lotperdu_libelle"
                      data-vv-scope="step6"
                      placeholder="Ex: Un code de reduction"
                    />
                  </div>

                  <div class="elem" v-if="form.type === 'JEU WEB'">
                    <label>TITRE</label>
                    <input
                      type="text"
                      v-model="custom.lotperdu_titre"
                      name="lotperdu_titre"
                      id="lotperdu_titre"
                      data-vv-scope="step6"
                      placeholder="Ex: Dommage vous avez perdu"
                    />
                  </div>

                  <div
                    class="elem"
                    style="width:100%"
                    v-if="form.type === 'JEU WEB'"
                  >
                    <label>DESCRIPTION</label>
                    <i
                      v-if="!htmlview[5]"
                      @click="toogleViewcode(5)"
                      class="fas fa-solid fa-code edithtml"
                    ></i>
                    <i
                      v-else
                      @click="toogleViewcode(5)"
                      class="fas fa-eye-slash edithtml"
                    ></i>
                    <quill-editor
                      v-if="!htmlview[5]"
                      class="editgab"
                      style="width:100%; height:150px"
                      ref="myQuillEditor"
                      v-model="custom.lotperdu_informations"
                      :options="editorOptionGabarit"
                    />
                    <prism-editor
                      v-if="htmlview[5]"
                      style="width:95%; height:170px"
                      class="my-editor"
                      :line-numbers="true"
                      :highlight="highlighter"
                      v-model="custom.lotperdu_informations"
                    ></prism-editor>
                  </div>

                  <div v-if="form.type === 'JEU WEB'" class="elem">
                    <label
                      >Image de la consolante&nbsp;&nbsp;<span
                        v-if="ifUploaded('lot_perdu')"
                        ><a :href="ifUploaded('lot_perdu')" targer="_blank"
                          ><i class="fas fa-eye"></i
                        ></a>
                        &nbsp;<i
                          v-on:click="deleteFile('lot_perdu')"
                          class="fa fa-trash"
                          aria-hidden="true"
                        ></i></span
                    ></label>
                    <div class="upload-btn-wrapper2">
                      <button class="btn2">
                        <i aria-hidden="true" class="fa fa-cloud-upload"></i>
                        Uploader l'image de la consolante
                      </button>
                      <input
                        type="file"
                        name="lot_perdu"
                        id="lot_perdu"
                        ref="lot_perdu"
                        :accept="
                          ['lot_perdu'].includes('lot_perdu')
                            ? '.png, .jpg, .jpeg, .gif'
                            : '.png,.mp4,.jpg,.ico'
                        "
                        v-on:change="singleUpload('lot_perdu')"
                      />
                    </div>
                    <span class="infosupup">(Format jpg, jpeg, png, gif)</span>
                  </div>

                  <div
                    style="width:100%;"
                    v-if="form.animation && form.type === 'JEU WEB'"
                  >
                    <h3 class="customtitle">
                      Texte de confirmation (Animations)
                      <i
                        v-on:click="nextStep()"
                        class="fas fa-save savestep"
                      ></i>
                    </h3>

                    <div style="width:97%">
                      <div
                        class="elem"
                        v-if="form.animation === 'ROUE DE LA CHANCE'"
                      >
                        <label>Roue de la chance (NB DE QUARTIERS) *</label>
                        <input
                          type="number"
                          v-model="custom.wheel_quarters"
                          placeholder="EX : 12"
                        />
                      </div>

                      <div
                        class="elem"
                        v-if="form.animation === 'ROUE DE LA CHANCE'"
                      >
                        <label>Roue de la chance (TEXTE DU BOUTON) *</label>
                        <input
                          type="text"
                          v-model="custom.wheel_button"
                          placeholder="EX : Tourner la roue"
                        />
                      </div>

                      <div class="elem" style="width:100%">
                        <label>Titre Animation (html ok) </label>
                        <i
                          v-if="!htmlview[6]"
                          @click="toogleViewcode(6)"
                          class="fas fa-solid fa-code edithtml"
                        ></i>
                        <i
                          v-else
                          @click="toogleViewcode(6)"
                          class="fas fa-eye-slash edithtml"
                        ></i>
                        <quill-editor
                          v-if="!htmlview[6]"
                          class="editgab"
                          style="width:100%; height:150px"
                          ref="myQuillEditor"
                          v-model="custom.titre_animation"
                          :options="editorOptionGabarit"
                        />
                        <prism-editor
                          v-if="htmlview[6]"
                          style="width:95%; height:170px"
                          class="my-editor"
                          :line-numbers="true"
                          :highlight="highlighter"
                          v-model="custom.titre_animation"
                        ></prism-editor>
                      </div>
                      <div class="elem" style="width:100%">
                        <label>Description Animation (html ok) </label>
                        <i
                          v-if="!htmlview[7]"
                          @click="toogleViewcode(7)"
                          class="fas fa-solid fa-code edithtml"
                        ></i>
                        <i
                          v-else
                          @click="toogleViewcode(7)"
                          class="fas fa-eye-slash edithtml"
                        ></i>
                        <quill-editor
                          v-if="!htmlview[7]"
                          class="editgab"
                          style="width:100%; height:150px"
                          ref="myQuillEditor"
                          v-model="custom.text_animation"
                          :options="editorOptionGabarit"
                        />
                        <prism-editor
                          v-if="htmlview[7]"
                          style="width:95%; height:170px"
                          class="my-editor"
                          :line-numbers="true"
                          :highlight="highlighter"
                          v-model="custom.text_animation"
                        ></prism-editor>
                      </div>

                      <h3
                        class="customtitle"
                        v-if="form.animation === 'ROUE DE LA CHANCE'"
                      >
                        Images de la roue de la chance
                        <i
                          v-on:click="nextStep()"
                          class="fas fa-save savestep"
                        ></i>
                      </h3>

                      <div
                        v-if="form.animation === 'ROUE DE LA CHANCE'"
                        class="infosgab"
                        style="margin-top:-5px;margin-bottom:10px"
                      >
                        <a
                          style="color:#444"
                          href="https://docs.google.com/document/d/1RE8Zg7Nug9At90fWii67W-mUTWpcLaAovtFdVtYPvuY/edit"
                          target="_blank"
                          ><i
                            class="fas fa-question-circle"
                            aria-hidden="true"
                          ></i>
                          Cliquer ici pour consulter notre documention sur la
                          mise en place de la roue de la chance.</a
                        >
                      </div>

                      <div
                        v-if="form.animation === 'ROUE DE LA CHANCE'"
                        class="elem"
                      >
                        <label
                          >Image de la roue&nbsp;&nbsp;<span
                            v-if="ifUploaded('wheel')"
                            ><a :href="ifUploaded('wheel')" targer="_blank"
                              ><i class="fas fa-eye"></i
                            ></a>
                            &nbsp;<i
                              v-on:click="deleteFile('wheel')"
                              class="fa fa-trash"
                              aria-hidden="true"
                            ></i></span
                        ></label>
                        <div class="upload-btn-wrapper2">
                          <button class="btn2">
                            <i
                              aria-hidden="true"
                              class="fa fa-cloud-upload"
                            ></i>
                            Uploader la roue
                          </button>
                          <input
                            type="file"
                            name="myfile"
                            id="file"
                            ref="wheel"
                            :accept="
                              ['wheel'].includes('wheel')
                                ? '.png, .jpg, .jpeg, .gif'
                                : '.png,.mp4,.jpg,.ico'
                            "
                            v-on:change="singleUpload('wheel')"
                          />
                        </div>
                        <span class="infosupup"
                          >(Format png Ratio 1/1 Carré)</span
                        >
                      </div>

                      <div
                        v-if="form.animation === 'ROUE DE LA CHANCE'"
                        class="elem"
                      >
                        <label
                          >Flèche de la roue&nbsp;&nbsp;<span
                            v-if="ifUploaded('wheel-arrow')"
                            ><a
                              :href="ifUploaded('wheel-arrow')"
                              targer="_blank"
                              ><i class="fas fa-eye"></i
                            ></a>
                            &nbsp;<i
                              v-on:click="deleteFile('wheel-arrow')"
                              class="fa fa-trash"
                              aria-hidden="true"
                            ></i></span
                        ></label>
                        <div class="upload-btn-wrapper2">
                          <button class="btn2">
                            <i
                              aria-hidden="true"
                              class="fa fa-cloud-upload"
                            ></i>
                            Uploader la flèche de la roue
                          </button>
                          <input
                            type="file"
                            name="wheel-arrow"
                            id="wheel-arrow"
                            ref="wheel-arrow"
                            :accept="
                              ['wheel-arrow'].includes('wheel-arrow')
                                ? '.png'
                                : '.png,.mp4,.jpg,.ico'
                            "
                            v-on:change="singleUpload('wheel-arrow')"
                          />
                        </div>
                        <span class="infosupup"
                          >(format jpg, jpeg, png, gif)</span
                        >
                      </div>

                      <div
                        v-if="form.animation === 'ROUE DE LA CHANCE'"
                        class="elem"
                      >
                        <label
                          >Rond central fixe de la roue&nbsp;&nbsp;<span
                            v-if="ifUploaded('wheel-center')"
                            ><a
                              :href="ifUploaded('wheel-center')"
                              targer="_blank"
                              ><i class="fas fa-eye"></i
                            ></a>
                            &nbsp;<i
                              v-on:click="deleteFile('wheel-center')"
                              class="fa fa-trash"
                              aria-hidden="true"
                            ></i></span
                        ></label>
                        <div class="upload-btn-wrapper2">
                          <button class="btn2">
                            <i
                              aria-hidden="true"
                              class="fa fa-cloud-upload"
                            ></i>
                            Uploader le rond central
                          </button>
                          <input
                            type="file"
                            name="myfile"
                            id="file"
                            ref="wheel-center"
                            :accept="
                              ['wheel-center'].includes('wheel-center')
                                ? '.png, .jpg, .jpeg, .gif'
                                : '.png,.mp4,.jpg,.ico'
                            "
                            v-on:change="singleUpload('wheel-center')"
                          />
                        </div>
                        <span class="infosupup"
                          >(format jpg, jpeg, png, gif)</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </v-tab>
              <v-tab title="Contact">
                <div style="width:100%;">
                  <h3 class="customtitle">
                    Contenu de la page de contact
                    <i v-on:click="nextStep()" class="fas fa-save savestep"></i>
                  </h3>
                </div>

                <div class="elem" style="width:97%">
                  <label style="width:100%">
                    <a
                      href="https://www.markdownguide.org/basic-syntax/"
                      style="color:red;text-decoration:none;font-size:12px;margin-left:30px;"
                      target="_blank"
                      >Syntaxe Markdown</a
                    >
                  </label>
                  <textarea
                    style="width:100%; height:450px"
                    v-model="form.contactezNous"
                  ></textarea>
                  <!--<quill-editor class="editgab"
                  style="width:100%; height:450px"
                  ref="myQuillEditor"
                  v-model="form.contactezNous"
                  :options="editorOptionGabarit"
                /> -->
                </div>
              </v-tab>

              <v-tab title="Mentions">
                <div style="width:100%;">
                  <h3 class="customtitle">
                    Mentions légales
                    <i v-on:click="nextStep()" class="fas fa-save savestep"></i>
                  </h3>
                </div>
                <div class="elem" style="width:97%">
                  <label>
                    <a
                      href="https://www.markdownguide.org/basic-syntax/"
                      style="color:red;text-decoration:none;font-size:12px;margin-left:30px;"
                      target="_blank"
                      >Syntaxe Markdown</a
                    >
                  </label>
                  <textarea
                    style="width:100%; height:450px"
                    v-model="form.mentionsLegales"
                  ></textarea>
                  <!--<quill-editor class="editgab"
                  style="width:100%; height:450px"
                  ref="myQuillEditor"
                  v-model="form.mentionsLegales"
                  :options="editorOptionGabarit"
                />-->
                </div>
              </v-tab>

              <v-tab title="Compteur">
                <h3 class="customtitle">
                  Gestion de l'affichage du compteur
                  <i v-on:click="nextStep()" class="fas fa-save savestep"></i>
                </h3>

                <div class="elem">
                  <label for="compteur">FORMAT DU COMPTEUR</label>
                  <select name="compteur" v-model="custom.compteur">
                    <option value="hidden">Invisible</option>
                    <option value="text">Texte</option>
                    <option value="progressbar">ProgressBar</option>
                  </select>
                </div>

                <div class="elem">
                  <label
                    >Visible à partir de ( 0 = visible tout le temps ):
                  </label>
                  <input
                    type="number"
                    v-model="custom.compteur_limit_visible"
                    name="compteur_limit_visible"
                    id="compteur_limit_visible"
                    data-vv-scope="step6"
                    placeholder="Ex: 500"
                  />
                </div>

                <div class="elem">
                  <label>Texte apres le chiffre du compteur </label>
                  <input
                    type="text"
                    v-model="custom.compteur_text_after"
                    name="custom.compteur_text_after"
                    id="custom.compteur_text_after"
                    data-vv-scope="step6"
                    placeholder="Ex: participations"
                  />
                </div>
              </v-tab>

              <v-tab title="Design">
                <div class="infosgab">
                  <a
                    style="color:#444"
                    href="https://docs.google.com/document/d/1K7UTq2KJZcKcMy-AY7Bz1rFM-RrjKvYAgRGpSgRhBX4/edit"
                    target="_blank"
                    ><i class="fas fa-question-circle" aria-hidden="true"></i>
                    Cliquer ici pour consulter notre documention.</a
                  >
                </div>

                <div class="step-contenair">
                  <div style="width:100%;">
                    <h3 class="customtitle">
                      Style<i
                        v-on:click="nextStep()"
                        class="fas fa-save savestep"
                      ></i>
                    </h3>
                  </div>

                  <div class="elem">
                    <label>Arrondi de la page (px)</label>
                    <input
                      type="number"
                      v-model="custom.border_radius_popup"
                      name="border_radius_popup"
                      id="border_radius_popup"
                      data-vv-scope="step6"
                      placeholder="Ex: 15"
                    />
                  </div>

                  <div class="elem">
                    <label>Arrondi des boutons (px)</label>
                    <input
                      type="number"
                      v-model="custom.border_radius_buttons"
                      name="border_radius_buttons"
                      id="border_radius_buttons"
                      data-vv-scope="step6"
                      placeholder="Ex: 60"
                    />
                  </div>

                  <div style="width:100%;">
                    <h3 class="customtitle">
                      Branding<i
                        v-on:click="nextStep()"
                        class="fas fa-save savestep"
                      ></i>
                    </h3>
                  </div>

                  <div class="elem">
                    <label
                      >Bannière de l’opération &nbsp;&nbsp;<span
                        v-if="ifUploaded('banner_mb')"
                        ><a :href="ifUploaded('banner_mb')" targer="_blank"
                          ><i class="fas fa-eye"></i
                        ></a>
                        &nbsp;<i
                          v-on:click="deleteFile('banner_mb')"
                          class="fa fa-trash"
                          aria-hidden="true"
                        ></i></span
                    ></label>
                    <div class="upload-btn-wrapper2">
                      <button class="btn2">
                        <i aria-hidden="true" class="fa fa-cloud-upload"></i>
                        Uploader la Bannière
                      </button>
                      <input
                        type="file"
                        name="myfile"
                        id="file"
                        ref="banner_mb"
                        :accept="
                          ['banner_mb'].includes('banner_mb')
                            ? '.jpeg, .jpg, .gif, .png'
                            : '.png,.mp4,.jpg,.ico'
                        "
                        v-on:change="singleUpload('banner_mb')"
                      />
                    </div>
                    <span class="infosupup"
                      >(800x800 pixels au format jpg, jpeg, png, gif)</span
                    >
                  </div>

                  <div class="elem">
                    <label
                      >Logo de l’opération &nbsp;&nbsp;<span
                        v-if="ifUploaded('logo1')"
                        ><a :href="ifUploaded('logo1')" targer="_blank"
                          ><i class="fas fa-eye"></i
                        ></a>
                        &nbsp;<i
                          v-on:click="deleteFile('logo1')"
                          class="fa fa-trash"
                          aria-hidden="true"
                        ></i></span
                    ></label>
                    <div class="upload-btn-wrapper2">
                      <button class="btn2">
                        <i aria-hidden="true" class="fa fa-cloud-upload"></i>
                        Uploader le logo
                      </button>
                      <input
                        type="file"
                        name="myfile"
                        id="file"
                        ref="logo1"
                        :accept="
                          ['logo1'].includes('logo1')
                            ? '.png'
                            : '.png,.mp4,.jpg,.ico'
                        "
                        v-on:change="singleUpload('logo1')"
                      />
                    </div>
                    <span class="infosupup">(png au ratio 16/9 rectangle)</span>
                  </div>
                  <div class="elem">
                    <label for="banner_disable_animation"
                      >Animation de la bannière</label
                    >
                    <div class="menumobilecustom">
                      <div>
                        <input
                          type="radio"
                          id="banner_disable_animation"
                          value="false"
                          v-model="custom.banner_disable_animation"
                        />
                        <label for="banner_disable_animation">Activer</label>
                      </div>
                      <div>
                        <input
                          type="radio"
                          id="banner_disable_animation2"
                          value="true"
                          v-model="custom.banner_disable_animation"
                        />
                        <label for="banner_disable_animation2"
                          >Desactiver</label
                        >
                      </div>
                    </div>
                  </div>

                  <div class="elem">
                    <label
                      >Favicon de l’opération &nbsp;&nbsp;<span
                        v-if="ifUploaded('favicon')"
                        ><a :href="ifUploaded('favicon')" targer="_blank"
                          ><i class="fas fa-eye"></i
                        ></a>
                        &nbsp;<i
                          v-on:click="deleteFile('favicon')"
                          class="fa fa-trash"
                          aria-hidden="true"
                        ></i></span
                    ></label>
                    <div class="upload-btn-wrapper2">
                      <button class="btn2">
                        <i aria-hidden="true" class="fa fa-cloud-upload"></i>
                        Uploader le favicon
                      </button>
                      <input
                        type="file"
                        name="myfile"
                        id="file"
                        ref="favicon"
                        :accept="
                          ['favicon'].includes('favicon')
                            ? '.png'
                            : '.png,.mp4,.jpg,.ico'
                        "
                        v-on:change="singleUpload('favicon')"
                      />
                    </div>
                    <span class="infosupup">(png au ratio 1/1 carré) </span>
                  </div>

                  <div class="elem">
                    <label>Titre de l’onglet navigateur </label>
                    <input
                      type="text"
                      v-model="custom.pagetitle"
                      name="pagetitle"
                      id="pagetitle"
                      data-vv-scope="step6"
                      placeholder="Ex: Dulux Valentine"
                    />
                  </div>

                  <div style="width:100%;">
                    <h3 class="customtitle">
                      Background (arriere plan du site)<i
                        v-on:click="nextStep()"
                        class="fas fa-save savestep"
                      ></i>
                    </h3>
                  </div>

                  <div class="elem">
                    <label for="banner_disable_animation"
                      >Type de background</label
                    >

                    <div class="menumobilecustom">
                      <div>
                        <input
                          type="radio"
                          id="default"
                          value="default"
                          v-model="custom.typebackground"
                        />
                        <label for="default">Default</label>
                      </div>
                      <div>
                        <input
                          type="radio"
                          id="image"
                          value="image"
                          v-model="custom.typebackground"
                        />
                        <label for="image">Image</label>
                      </div>
                      <div>
                        <input
                          type="radio"
                          id="couleur"
                          value="couleur"
                          v-model="custom.typebackground"
                        />
                        <label for="couleur">Couleur</label>
                      </div>
                    </div>
                    <div
                      v-if="custom.typebackground === 'couleur'"
                      style="width:100%;margin-top:20px;"
                    >
                      <div class="colorfill">
                        <div
                          class="pickerview"
                          :style="
                            `background-color:${custom.body_background_color}`
                          "
                        >
                          <verte
                            model="hex"
                            picker="wheel"
                            menuPosition="top"
                            v-model="custom.body_background_color"
                          >
                          </verte>
                        </div>
                        <label for="body_background_color"
                          >Couleur du background (Body)
                        </label>
                      </div>
                    </div>

                    <div
                      v-if="custom.typebackground === 'image'"
                      style="width:100%;margin-top:20px;"
                    >
                      <label
                        >IMAGE DE FOND DU SITE &nbsp;&nbsp;<span
                          v-if="ifUploaded('background_mb')"
                          ><a
                            :href="ifUploaded('background_mb')"
                            targer="_blank"
                            ><i class="fas fa-eye"></i
                          ></a>
                          &nbsp;<i
                            v-on:click="deleteFile('background_mb')"
                            class="fa fa-trash"
                            aria-hidden="true"
                          ></i></span
                      ></label>
                      <div class="upload-btn-wrapper2">
                        <button class="btn2">
                          <i aria-hidden="true" class="fa fa-cloud-upload"></i>
                          Uploader la Bannière
                        </button>
                        <input
                          type="file"
                          name="myfile"
                          id="file"
                          ref="background_mb"
                          :accept="
                            ['background_mb'].includes('background_mb')
                              ? '.jpeg, .jpg, .gif, .png'
                              : '.png,.mp4,.jpg,.ico'
                          "
                          v-on:change="singleUpload('background_mb')"
                        />
                      </div>
                      <span class="infosupup"
                        >(format jpg, jpeg, png, gif)
                      </span>
                    </div>
                  </div>

                  <div style="width:100%;">
                    <h3 class="customtitle">
                      Couleur & Police<i
                        v-on:click="nextStep()"
                        class="fas fa-save savestep"
                      ></i>
                    </h3>
                  </div>

                  <div class="elem">
                    <label>Police (font)</label>
                    <input
                      type="text"
                      v-model="custom.font_family"
                      name="font_family"
                      id="font_family"
                      data-vv-scope="step6"
                      placeholder="Ex: Roboto"
                    />
                  </div>

                  <div class="elem">
                    <label>Taille de la police (Dans le body)</label>
                    <input
                      type="number"
                      v-model="custom.font_size"
                      name="font_size"
                      id="font_size"
                      data-vv-scope="step6"
                      placeholder="16"
                    />
                  </div>

                  <div class="elem">
                    <div class="colorfill">
                      <div
                        class="pickerview"
                        :style="`background-color:${custom.primary_color_bg}`"
                      >
                        <verte
                          model="hex"
                          picker="wheel"
                          menuPosition="top"
                          v-model="custom.primary_color_bg"
                        >
                        </verte>
                      </div>
                      <label for="primary_color_bg"
                        >Couleur de fond principale
                      </label>
                    </div>
                  </div>

                  <div class="elem">
                    <div class="colorfill">
                      <div
                        class="pickerview"
                        :style="`background-color:${custom.primary_color_txt}`"
                      >
                        <verte
                          model="hex"
                          picker="wheel"
                          menuPosition="top"
                          v-model="custom.primary_color_txt"
                        >
                        </verte>
                      </div>
                      <label for="primary_color_txt"
                        >Couleur de la police principale
                      </label>
                    </div>
                  </div>

                  <div class="elem">
                    <div class="colorfill">
                      <div
                        class="pickerview"
                        :style="`background-color:${custom.secondary_color_bg}`"
                      >
                        <verte
                          model="hex"
                          picker="wheel"
                          menuPosition="top"
                          v-model="custom.secondary_color_bg"
                        >
                        </verte>
                      </div>
                      <label for="secondary_color_bg"
                        >Couleur de fond secondaire
                      </label>
                    </div>
                  </div>

                  <div class="elem">
                    <div class="colorfill">
                      <div
                        class="pickerview"
                        :style="
                          `background-color:${custom.secondary_color_txt}`
                        "
                      >
                        <verte
                          picker="wheel"
                          model="hex"
                          menuPosition="top"
                          v-model="custom.secondary_color_txt"
                        >
                        </verte>
                      </div>
                      <label for="secondary_color_txt"
                        >Couleur de la police secondaire
                      </label>
                    </div>
                  </div>

                  <div style="width:100%;">
                    <h3 class="customtitle">
                      Règles CSS custom<i
                        v-on:click="nextStep()"
                        class="fas fa-save savestep"
                      ></i>
                    </h3>
                  </div>

                  <div class="elem" style="width: 98%;">
                    <label></label>
                    <prism-editor
                      style="width:98.5%; height:170px"
                      class="my-editor"
                      :line-numbers="true"
                      :highlight="highlighter"
                      v-model="custom.custom_css"
                    ></prism-editor>
                  </div>
                </div>
              </v-tab>

              <v-tab title="Notifications">
                <div style="width:100%;">
                  <h3 class="customtitle">
                    Documents (facultatif)
                    <i v-on:click="nextStep()" class="fas fa-save savestep"></i>
                  </h3>
                </div>

                <div class="elem">
                  <label
                    >Bannière dans l'email &nbsp;&nbsp;<span
                      v-if="ifUploaded('emailbanner')"
                      ><a :href="ifUploaded('emailbanner')" targer="_blank"
                        ><i class="fas fa-eye"></i
                      ></a>
                      &nbsp;<i
                        v-on:click="deleteFile('emailbanner')"
                        class="fa fa-trash"
                        aria-hidden="true"
                      ></i></span
                  ></label>
                  <div class="upload-btn-wrapper2">
                    <button class="btn2">
                      <i aria-hidden="true" class="fa fa-cloud-upload"></i>
                      Uploader l'image
                    </button>
                    <input
                      type="file"
                      name="myfile"
                      id="file"
                      ref="emailbanner"
                      :accept="
                        ['emailbanner'].includes('emailbanner')
                          ? '.png'
                          : '.png,.mp4,.jpg,.ico'
                      "
                      v-on:change="singleUpload('emailbanner')"
                    />
                  </div>
                  <span class="infosupup">(png au ratio 1/1 carré) </span>
                </div>

                <div style="width:100%;">
                  <h3 class="customtitle">
                    Gestion des Emails
                    <i v-on:click="nextStep()" class="fas fa-save savestep"></i>
                  </h3>
                </div>

                <div class="step-contenair">
                  <div class="elem">
                    <label for="mailexp">Adresse email de l'expéditeur</label>
                    <input
                      type="email"
                      v-model="emailConfig.email"
                      name="mailexp"
                      id="mailexp"
                      data-vv-scope="step3"
                      placeholder="Adresse email de l'expéditeur"
                    />
                    <div class="error">{{ errors.first("step3.mailexp") }}</div>
                  </div>
                  <!-- <div class="elem">
                    <label for="mailexp">Compte Mailjet</label>
                    <select name="mailjet" v-model="emailConfig.mailjetAccount">
                      <option value="oxone">Oxone</option>
                      <option value="promodev">Promodev</option>
                    </select>
                  </div> -->
                  <div class="elem">
                    <label for="nameexp">Nom de l'expéditeur</label>
                    <input
                      type="text"
                      v-model="emailConfig.name"
                      name="nameexp"
                      id="nameexp"
                      data-vv-scope="step3"
                      placeholder="Nom de l'expéditeur"
                    />

                    <div class="error">{{ errors.first("step3.nameexp") }}</div>
                  </div>

                  <div class="drop">
                    <hr />
                    <div style="display:flex;">
                      <div style="width:17%;padding-left:1%">
                        <label>Type : </label>
                      </div>
                      <div style="width:12%;padding-left:1%">
                        <label>Template ID : </label>
                      </div>
                      <div style="width:60%;padding-left:1%">
                        <label>Sujet : </label>
                      </div>
                    </div>
                    <div
                      class="drop-container"
                      v-for="(item, i) in emails"
                      :key="i"
                    >
                      <div class="elem" style="width:20%; height:40px;">
                        <input
                          type="text"
                          v-model="item.type"
                          placeholder="Ex. lot1"
                        />
                      </div>

                      <div class="elem" style="width:15%">
                        <input
                          type="text"
                          v-model="item.templateID"
                          placeholder="Identifiant du template"
                        />
                      </div>

                      <div class="elem" style="width:650px">
                        <input
                          type="text"
                          style="width:900px"
                          v-model="item.sujet"
                          placeholder="Sujet de l'email"
                        />
                        <i
                          class="fa fa-edit editOption"
                          aria-hidden="true"
                          v-on:click="editTemplate(i, item)"
                        ></i>
                        <i
                          class="fa fa-minus-circle deleteOption"
                          aria-hidden="true"
                          v-on:click="deleteLot(i)"
                        ></i>
                      </div>
                    </div>
                    <div class="addDrop">
                      <span v-on:click="addLot()"
                        ><i class="fa fa-plus-square" v-on:click="addLot()"></i>
                        &nbsp;Ajouter un template</span
                      >
                    </div>
                    <br />
                    <br />
                    <br />
                  </div>

                  <div class="elem" style="width: 100%;">
                    <label>Template SMS (handlebar) :</label>
                    <input
                      type="text"
                      v-model="form.smsTemplate"
                      placeholder="Template SMS"
                    />
                  </div>
                  <div style="width:100%;">
                    <h3 class="customtitle">
                      Configuration des motifs de non conformité
                      <i
                        v-on:click="nextStep()"
                        class="fas fa-save savestep"
                      ></i>
                    </h3>
                  </div>

                  <div class="elem" style="width: 100%;">
                    <label>MISSING</label>
                    <textarea v-model="MISSING"></textarea>
                  </div>
                  <div class="elem" style="width: 100%;">
                    <label>UNREADABLE</label>
                    <textarea v-model="UNREADABLE"></textarea>
                  </div>
                  <div class="elem" style="width: 100%;">
                    <label>INVALID</label>
                    <textarea v-model="INVALID"></textarea>
                  </div>
                </div>
              </v-tab>
            </vue-tabs>
          </div>

          <div class="step-contenair" v-if="step == 1">
            <div style="width:100%;">
              <h3 class="customtitle">
                <span
                  >Informations générales
                  <a @click="downloadCdctoxml(form._id, form.title)"
                    ><i
                      v-tooltip="'Generer le cahier des charges'"
                      class="fa fa-file"
                      aria-hidden="true"
                    ></i></a
                ></span>
                <i v-on:click="nextStep()" class="fas fa-save savestep"></i>
              </h3>
            </div>

            <div class="elem">
              <label for="title">titre <span>*</span></label>
              <input
                type="text"
                id="title"
                name="title"
                v-validate="'required'"
                v-model="form.title"
                data-vv-scope="step1"
                placeholder="Titre de l'opération"
              />
              <div class="error">{{ errors.first("step1.title") }}</div>
            </div>

            <div class="elem">
              <label>Client</label>
              <multiselect
                v-if="clientList"
                v-model="form.client"
                :options="clientList"
                name="client"
                id="client"
                :searchable="false"
                :show-labels="false"
                data-vv-scope="step2"
                placeholder="Environnement"
              >
              </multiselect>
            </div>

            <div class="elem">
              <label>type </label>
              <multiselect
                v-model="form.type"
                :options="typeList"
                name="type"
                id="type"
                :searchable="false"
                :show-labels="false"
                data-vv-scope="step1"
                placeholder="Type de jeu"
              >
              </multiselect>
              <div class="error">{{ errors.first("step1.type") }}</div>
            </div>

            <div class="elem">
              <label>format</label>
              <multiselect
                v-model="form.format"
                :options="envList2"
                name="format"
                id="format"
                :searchable="false"
                :show-labels="false"
                v-validate="'required'"
                data-vv-scope="step2"
                placeholder="Format"
              >
              </multiselect>
              <div class="error">{{ errors.first("step2.env") }}</div>
            </div>

            <div class="elem">
              <label>Description </label>
              <textarea
                id="description"
                name="description"
                v-model="form.description"
                placeholder="Ajouter une description"
              ></textarea>
            </div>

            <div class="elem">
              <label>language <span>*</span></label>
              <multiselect
                v-model="form.pays"
                vee-mode="passif"
                :options="paysList"
                :multiple="false"
                select-label="Cliquez pour ajouter"
                deselect-label="Cliquez pour supprimer"
                placeholder="Choix du pays"
                label="name"
                name="pays"
                id="pays"
                data-vv-scope="step1"
                :custom-label="getCodePays"
              >
              </multiselect>
              <div class="error">{{ errors.first("step1.pays") }}</div>
            </div>

            <div style="width:100%;">
              <h3 class="customtitle">
                Dates de l'opération
                <i v-on:click="nextStep()" class="fas fa-save savestep"></i>
              </h3>
            </div>

            <div class="elem">
              <label>date de début (opération)</label>
              <template>
                <vue-datepicker-local
                  name="date_debut"
                  :local="local"
                  data-vv-scope="step1"
                  format="DD MMMM YYYY HH:mm:ss"
                  v-model="form.date_debut"
                />
              </template>
              <div class="error">{{ errors.first("step1.date_debut") }}</div>
            </div>
            <div class="elem">
              <label>date de fin (opération)</label>
              <template>
                <vue-datepicker-local
                  name="date_fin"
                  :local="local"
                  data-vv-scope="step1"
                  format="DD MMMM YYYY HH:mm:ss"
                  v-model="form.date_fin"
                />
              </template>
              <div class="error">{{ errors.first("step1.date_fin") }}</div>
            </div>

            <div class="elem">
              <label>date de fin des vérification (opération)</label>
              <template>
                <vue-datepicker-local
                  name="date_fin_reclamation"
                  :local="local"
                  data-vv-scope="step1"
                  format="DD MMMM YYYY HH:mm:ss"
                  v-model="form.date_fin_reclamation"
                />
              </template>
              <div class="error">{{ errors.first("step1.date_fin_reclamation") }}</div>
            </div>

            <div class="elem">
              <label>date de fin des régularisation</label>
              <template>
                <vue-datepicker-local
                  name="date_fin_regule"
                  :local="local"
                  data-vv-scope="step1"
                  format="DD MMMM YYYY HH:mm:ss"
                  v-model="form.date_fin_regule"
                />
              </template>
              <div class="error">{{ errors.first("step1.date_fin_regule") }}</div>
            </div>   
 

            <div
              v-if="form.type === 'JEU WEB' || form.type === 'JEU SOA'"
              class="elem"
            >
              <label>Animation</label>
              <multiselect
                v-model="form.animation"
                :options="animationsList"
                name="animation"
                id="animation"
                :searchable="false"
                :show-labels="false"
                data-vv-scope="step1"
                placeholder="Par defaut aucune"
              >
              </multiselect>
              <div class="error">{{ errors.first("step1.type") }}</div>
            </div>

            <div class="elem">
              <label>date de fin (achat)</label>
              <template>
                <vue-datepicker-local
                  name="date_fin_achat"
                  :local="local"
                  data-vv-scope="step1"
                  format="DD MMMM YYYY HH:mm:ss"
                  v-model="form.date_fin_achat"
                />
              </template>
              <div class="error">
                {{ errors.first("step1.date_fin_achat") }}
              </div>
            </div>

            <div style="width:100%;">
              <h3 class="customtitle">
                Gestion de projet
                <i v-on:click="nextStep()" class="fas fa-save savestep"></i>
              </h3>
            </div>

            <div class="elem">
              <label for="notions"
                >lien Statistiques&nbsp;<a
                  :href='`https://stats.promo.dev/${form._id}`'
                  style="color:#444"
                  target="_blank"
                  ><i class="fas fa-eye"></i></a
              ></label>
            </div>

            <div class="elem">
              <label for="notions"
                >lien clickup &nbsp;<a
                  :href="`${form.notions}`"
                  style="color:#444"
                  target="_blank"
                  ><i class="fas fa-eye"></i></a
              ></label>
              <input
                type="text"
                id="notions"
                name="notions"
                v-model="form.notions"
                data-vv-scope="step1"
                placeholder="URL du lien clickup"
              />
              <div class="error">{{ errors.first("step1.notions") }}</div>
            </div>

            <div class="elem" style="width:100%;margin-bottom:20px;">
              <label>Instructions de saisie</label>
              <i
                v-if="!htmlview[0]"
                @click="toogleViewcode(8)"
                class="fas fa-solid fa-code edithtml"
              ></i>
              <i
                v-else
                @click="toogleViewcode(8)"
                class="fas fa-eye-slash edithtml"
              ></i>
              <quill-editor
                v-if="!htmlview[8]"
                class="editgab"
                style="width:100%; height:150px"
                ref="myQuillEditor"
                v-model="form.saisieInstructions"
                :options="editorOptionGabarit"
              />
              <prism-editor
                v-if="htmlview[8]"
                style="width:95%; height:170px"
                class="my-editor"
                :line-numbers="true"
                :highlight="highlighter"
                v-model="form.saisieInstructions"
              ></prism-editor>
            </div>
            <div class="elem" style="width: 100%;">
              <label>Schema Saisie (json):</label>
              <prism-editor
                style="width:98%; height:170px"
                class="my-editor"
                :line-numbers="true"
                :highlight="highlighter"
                v-model="form.saisieFormSchema"
              ></prism-editor>
            </div>

            <div class="elem">
              <br />
              <button class="btn-blue" type="button" v-on:click="nextStep()">
                <i class="fa fa-save"></i> Sauvegarder
              </button>
            </div>
          </div>
          <div class="step-contenair" v-if="step == 2">
            <div style="width:100%;">
              <h3>Configuration technique</h3>
            </div>

            <div class="elem">
              <label for="available">Status de l'opération</label>
              <div class="menumobilecustom">
                <div>
                  <input
                    type="radio"
                    id="available2"
                    value="false"
                    v-model="form.available"
                  />
                  <label for="available2">Offline</label>
                </div>

                <div>
                  <input
                    type="radio"
                    id="available"
                    value="true"
                    v-model="form.available"
                  />
                  <label for="available">Online</label>
                </div>
              </div>
            </div>

            <!-- <div class="elem">
              <label>environnement</label>
              <multiselect
                v-model="form.env"
                :options="envList"
                name="env"
                id="env"
                :searchable="false"
                :show-labels="false"
                v-validate="'required'"
                data-vv-scope="step2"
                placeholder="Environnement"
              >
              </multiselect>
              <div class="error">{{ errors.first("step2.env") }}</div>
            </div> -->

            <div class="elem">
              <label>État des domaines</label>
              <div class="dnscheck">
                  <p v-if="dnsCheck.loading">
                    <i class="fas fa-spinner fa-pulse"></i>
                    Chargement de l'état des domaines...
                  </p>
                  <p v-else-if="dnsCheck.error" class="warning">
                    <i class="fas fa-exclamation-triangle"></i>
                    Erreur lors de la récupération de l'état des domaines.
                  </p>
                  <p>
                    <span v-for="domain, i in dnsCheck.domains" :key="i">
                      <b v-if="i > 0">&nbsp;/&nbsp;</b>
                      <b>{{ domain.title }} - </b>
                      <span v-if="domain.success" class="success">
                        <i class="fas fa-check-circle"></i>
                        Domaine OK
                      </span>
                      <span v-else class="error">
                      <i class="fas fa-exclamation-triangle"></i>
                        Domaine NOK : {{ domain.code }}
                      </span>
                    </span>
                  </p>
              </div>
            </div>

            <div class="elem">
              <label>ID GAME</label>
              <input
                type="text"
                v-model="form.idgame"
                name="idgame"
                id="idgame"
                data-vv-scope="step2"
                placeholder="Ex: danao18"
              />
              <div class="error">{{ errors.first("step2.idgame") }}</div>
            </div>

            <div class="elem">
              <label
                >nom de domaine (PROD)
                <i
                  v-if="form.domaine"
                  @click="goToProd(form.domaine)"
                  class="far fa-eye"
                ></i
              ></label>
              <input
                type="text"
                v-model="form.domaine"
                name="domaine"
                id="domaine"
                @change="updateDomains"
                data-vv-scope="step2"
                placeholder="domaine"
              />
              <div class="error">{{ errors.first("step2.domaine") }}</div>
            </div>
            <div class="elem">
              <label
                >nom de domaine (DEV)
                <i
                  v-if="form.domaine_dev"
                  @click="goToProd(form.domaine_dev)"
                  class="far fa-eye"
                ></i
              ></label>
              <input
                type="text"
                v-model="form.domaine_dev"
                name="domaine_dev"
                id="domaine_dev"
                data-vv-scope="step2"
                placeholder="domaine (dev)"
              />
              <div class="error">{{ errors.first("step2.domaine_dev") }}</div>
            </div>

            <div class="elem">
              <label>Date de suppression des données (interne)</label>
              <template>
                <vue-datepicker-local
                  name="date_delete_data"
                  :local="local"
                  data-vv-scope="step2"
                  format="DD MMMM YYYY HH:mm:ss"
                  v-model="form.date_delete_data"
                />
              </template>
              <div class="error">
                {{ errors.first("step2.date_delete_data") }}
              </div>
            </div>

            <div class="elem">
              <label>Date d’anonymisation des données (interne)</label>
              <template>
                <vue-datepicker-local
                  name="date_anonymisation_data"
                  :local="local"
                  data-vv-scope="step2"
                  format="DD MMMM YYYY HH:mm:ss"
                  v-model="form.date_anonymisation_data"
                />
              </template>
              <div class="error">
                {{ errors.first("step2.date_anonymisation_data") }}
              </div>
            </div>

            <div class="elem">
              <label>Re-captcha V3 Public : </label>
              <input
                type="text"
                name="recpatcha-publicv3"
                id="recaptcha-publicv3"
                data-vv-scope="step2"
                v-model="form.recaptchaV3Public"
                placeholder="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
              />
            </div>
            <div class="elem">
              <label>Re-captcha V3 Private : </label>
              <input
                type="text"
                name="recaptcha-privev3"
                id="recaptcha-privev3"
                data-vv-scope="step2"
                v-model="form.recaptchaV3Private"
                placeholder="6LeIxAcTAAAAAGG-vFI1TnRWxMZNFuojJ4WifJWe"
              />
            </div>
            <div class="elem">
              <label>Google Map Key </label>
              <input
                type="text"
                name="recaptcha-prive"
                id="recaptcha-prive"
                data-vv-scope="step2"
                v-model="form.gmapkey"
                placeholder="Ex: AIzaSyBJ8R3BsCvNwNlcsjITn2IedKR8Y1Hvfzs"
              />
            </div>

            <div class="elem">
              <label>Analytics tracking id </label>
              <input
                type="text"
                name="tracking"
                id="tracking"
                data-vv-scope="step2"
                v-model="form.tracking"
                placeholder="Ex: UA-000DD47"
              />
            </div>

            <div class="elem checkbox">
              <label for="bot">Désactiver le controle par le bot</label>
              <input
                id="bot"
                type="checkbox"
                name="form.disablebot"
                v-model="form.disablebot"
              />
              <div class="error">{{ errors.first("step2.disablebot") }}</div>
            </div>

            <div class="elem">
              <label>URL DU FORMULAIRE (CONTROLE DU BOT)</label>
              <input
                type="text"
                name="checkurl"
                id="checkurl"
                data-vv-scope="step2"
                v-model="form.checkurl"
                placeholder="https://"
              />
            </div>

            <div class="elem checkbox">
              <label for="ip">IP unique</label>
              <input
                id="ip"
                type="checkbox"
                name="form.ipUniq"
                v-model="form.ipUniq"
              />
              <div class="error">{{ errors.first("step2.doublon") }}</div>
            </div>

            <div class="elem">
              <label>REDIRECTION APRÈS VALIDATION </label>
              <input
                type="text"
                name="redirection"
                id="redirection"
                data-vv-scope="step2"
                v-model="form.redirection_after_valid"
                placeholder="Ex: https://"
              />
            </div>

            <div class="elem checkbox">
              <label for="archived">Archiver l'opération</label>
              <input
                id="archived"
                type="checkbox"
                name="form.archived"
                v-model="form.archived"
              />
              <div class="error">{{ errors.first("step2.archived") }}</div>
            </div>    

            <div class="elem">
              <button class="btn-blue" type="button" v-on:click="nextStep()">
                <i class="fa fa-save"></i> Sauvegarder
              </button>
            </div>
          </div>
          <div class="step-contenair" v-if="step == 3">
            <div class="elem">
              <button class="btn-blue" type="button" v-on:click="nextStep()">
                <i class="fa fa-save"></i> Sauvegarder
              </button>
            </div>
          </div>
          <div v-if="step == 4">
            <br />
            <h3>
              &nbsp;
              <i class="fa fa-cloud-upload" aria-hidden="true"></i> &nbsp;
              Uploadez les documents relatifs à cette opération
            </h3>
            <div class="upl">
              <div
                class="files"
                v-for="(item, index) in files"
                v-bind:key="index"
              >
                <div>
                  <a
                    :href="item.uri"
                    target="_blank"
                    style="color:black;text-decoration:none;"
                    ><i class="fa fa-file-text-o" aria-hidden="true"></i> &nbsp;
                    {{ item.filename }}</a
                  >
                </div>
                <div>{{ item.size }}</div>
                <div>{{ item.date | formatDate }}</div>
                <div style="text-align:right;">
                  <i
                    v-if="item.reglement"
                    class="fa fa-book"
                    style="color:green"
                    aria-hidden="true"
                    v-on:click="setToReglement(item.filename)"
                  ></i>
                  <i
                    v-if="!item.reglement"
                    class="fa fa-book"
                    style="opacity: 0.33;"
                    aria-hidden="true"
                    v-on:click="setToReglement(item.filename)"
                  ></i>
                  &nbsp;
                  <a :href="item.uri" target="_blank" style="color:#444"
                    ><i class="fa fa-eye" aria-hidden="true"></i
                  ></a>
                  &nbsp;
                  <i
                    v-on:click="deleteFile(item.filename)"
                    class="fa fa-trash"
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
              <br />
              <br />
              <div class="elem upload_wrapper">
                <label>Séléctionnez un fichier</label>
                <select v-model="filename">
                  <option value="logo2">logo2.png</option>
                  <option value="charte">charte.pdf</option>
                  <option value="modalites-pro">modalites-pro.pdf</option>
                  <option value="reglement-pro">reglement-pro.pdf</option>
                  <option value="cookies">cookies.pdf</option>
                  <option value="banner_video">banner_video.mp4</option>
                  <option value="banner">banner.png</option>
                  <option value="banner_mobile">banner_mobile.png</option>
                  <option value="banner_mb2">banner_mb2.jpg</option>
                  <option value="flyer">flyer.pdf</option>
                  <option value="mentions">mentions.pdf</option>
                  <option value="partenaires">partenaires.pdf</option>
                  <option value="scratch-background"
                    >scratch-background.png</option
                  >
                  <option value="scratch-bottom-lose"
                    >scratch-bottom-lose.png</option
                  >
                  <option value="scratch-bottom-win"
                    >scratch-bottom-win.png</option
                  >
                  <option value="scratch-top">scratch-top.png</option>
                  <option value="lot1">lot1.png</option>
                  <option value="lot2">lot2.png</option>
                  <option value="lot3">lot3.png</option>
                  <option value="lot4">lot4.png</option>
                  <option value="lot5">lot5.png</option>
                  <option value="lot6">lot6.png</option>
                  <option value="lot7">lot7.png</option>
                  <option value="lot8">lot8.png</option>
                  <option value="lot9">lot9.png</option>
                  <option value="lot10">lot10.png</option>
                  <option value="background_mb">background_mb.jpg</option>
                </select>
                <div class="upload-btn-wrapper" v-if="filename">
                  <button class="btn">Envoyer un fichier</button>
                  <input
                    type="file"
                    name="myfile"
                    id="file"
                    ref="file"
                    :accept="
                      [
                        'reglement',
                        'reglement-pro',
                        'politique',
                        'charte',
                        'flyer',
                        'modalites-pro',
                        'partenaires',
                        'modalites',
                        'mentions',
                      ].includes(filename)
                        ? '.pdf'
                        : '.png,.mp4,.jpg,.ico'
                    "
                    v-on:change="handleFileUpload()"
                  />
                </div>
              </div>
            </div>
            <div v-if="we_links.length > 0" class="webloc">
              <h3>
                &nbsp;
                <i class="fa fa-cloud-upload" aria-hidden="true"></i> &nbsp;
                Lien Wetransfer

                <ul>
                  <li v-for="links in we_links" :key="links.index">
                    <a :href="`https://${links.url}`" target="_blank">{{
                      links.description
                    }}</a>
                    &nbsp; &nbsp;
                    <span>( {{ links.createdAt | formatDate }} )</span>
                  </li>
                </ul>
              </h3>
            </div>

            <div style="width:100% !important; margin-top:20px;">
              <button class="btn-blue" type="button" @click="saveMention()">
                <i class="fa fa-save"></i> Sauvegarder
              </button>
            </div>
          </div>
          <div v-if="step == 5">
            <br />
            <h3>Formulaire(s)</h3>
            <router-link
              tag="button"
              style="padding: 5px 10px; margin-bottom: 10px;"
              class="btn-blue"
              :to="'/data/' + form._id"
              >Consulter les participations</router-link
            >&nbsp;&nbsp;
            <a
              style="padding: 5px 10px; margin-bottom: 10px; cursor: pointer;"
              class="btn-blue"
              @click="openRegule = true"
              >REGULE</a
            >

            <div class="bloc-ope">
              <div
                v-for="(formulaire, index) in formulaires"
                :key="formulaire._id"
              >
                <div class="bloc-info" :class="formulaire.type">
                  <div class="container content-forms" style="padding:20px;">
                    <div class="edit">
                      <a
                        v-if="formulaire.type === 'CREATE'"
                        @click="previewForm(formulaire._id)"
                        ><i class="far fa-eye"></i
                      ></a>
                      &nbsp;
                      <router-link :to="'/formulaireV2/' + formulaire._id">
                        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                      </router-link>
                      &nbsp;
                      <a @click="cloneForm(formulaire)"
                        ><i
                          class="fa fa-clone"
                          v-tooltip="'Cloner vers ...'"
                          aria-hidden="true"
                        ></i></a
                      >&nbsp;
                      <a
                        @click.prevent="deleteForm(formulaire._id, index)"
                        href="#"
                      >
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </a>
                    </div>
                    <h2 style="margin: 0px;">
                      <router-link
                        :to="'/formulaireV2/' + formulaire._id"
                        style="color:#254FB2"
                        >{{
                          formulaire.description || formulaire.type
                        }}</router-link
                      >
                    </h2>
                    <br />
                    <div class="status-key2">
                      <div>
                        Type :
                        <b>{{ formulaire.type }}</b>
                      </div>
                      <div>
                        Langue :
                        <b>{{ formulaire.lang || form.lang }}</b>
                      </div>
                      <div>
                        <span
                          v-clipboard:copy="formulaire._id"
                          v-clipboard:success="onCopy"
                          class="key"
                          >Clé API :
                          <b
                            >{{ formulaire._id }}
                            <i class="fa fa-files-o" aria-hidden="true"></i
                          ></b>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="addcounter">
              <h3>Ajouter un formulaire</h3>
              <div class="elem">
                <label>Type de formulaire</label>
                <multiselect
                  v-model="newForm.type"
                  id="newForm.type"
                  :options="['CREATE', 'UPDATE', 'LINE_ITEM']"
                  :multiple="false"
                  v-validate="'required'"
                  :searchable="false"
                  name="type"
                  placeholder="Type de formulaire"
                  select-label="Cliquez pour ajouter"
                  deselect-label="Cliquez pour supprimer"
                ></multiselect>
              </div>
              <div class="elem">
                <label>Langue</label>
                <multiselect
                  v-model="newForm.lang"
                  id="newForm.lang"
                  :options="[
                    'de',
                    'fr',
                    'be-fr',
                    'be-nl',
                    'nl',
                    'pl',
                    'es-es',
                    'es-cat',
                    'it',
                    'en',
                    'lu-fr',
                    'lu-nl',
                    'ro',
                    'sl',
                    'bg',
                    'gr',
                  ]"
                  :multiple="false"
                  v-validate="'required'"
                  :searchable="false"
                  name="type"
                  placeholder="Lang"
                  select-label="Cliquez pour ajouter"
                  deselect-label="Cliquez pour supprimer"
                ></multiselect>
              </div>
              <div class="elem">
                <label>Description</label>
                <input
                  type="text"
                  name="champCode"
                  id="champCode"
                  data-vv-scope="step2"
                  v-model="newForm.description"
                />
              </div>
              <br />
              <button class="btn-blue" type="button" @click="createForm()">
                <i class="fa fa-plus"></i> Ajouter le formulaire
              </button>
            </div>
          </div>
          <div class="step-contenair add_counter" v-if="step == 8">
            <br /><br />
            <div class="bloc-ope">
              <div
                v-for="(counter, index) in counters"
                :key="index"
                :class="{ cmptedit: index === activeItem }"
              >
                <div class="bloc-info">
                  <div class="compteur-menu">
                    <a @click="selectItem(index)" v-if="index != activeItem"
                      ><i aria-hidden="true" class="fa fa-pencil-square-o"></i
                    ></a>
                    <a
                      @click.prevent="saveCounter(index)"
                      v-if="index === activeItem"
                      ><i aria-hidden="true" class="fa fa-save"></i
                    ></a>
                    <a @click.prevent="deleteCounter(index)"
                      ><i aria-hidden="true" class="fa fa-trash"></i
                    ></a>
                  </div>
                  <div class="container" style="padding:20px;">
                    <h2 class="cpt-title" style="margin: 0px;">
                      <b v-if="index != activeItem">{{ counter.name }}</b>
                      <input
                        v-if="index === activeItem"
                        type="text"
                        v-model="counter.name"
                      />  <p v-if="index === activeItem" style="font-size:14px; display: inline-block;margin-left:50px;">COUNT TYPE : <select style="width:100px" v-model="counter.increment">
                            <option value="false">Decrement</option>
                          <option value="true">Increment</option>                           
                      </select></p>
                      <p style="font-size:14px; display: inline-block;margin-left:50px;" v-else> COUNTER TYPE : <span v-if="counter.increment">Increment</span><span v-else >Decrement</span></p>
                      </h2>
                    
                    <br />
                    <div class="status-key">
                      <div>
                        <b>Type : </b>
                        <span class="typeCmpt" v-if="index != activeItem">
                          <b
                            :class="{
                              typeGreen: counter.type === 'LIMITATIVE',
                            }"
                          >
                            &nbsp;{{ counter.type }}
                          </b>
                        </span>
                        <select
                          v-if="index === activeItem"
                          v-model="counter.type"
                        >
                          <option>LIMITATIVE</option>
                          <option>INFORMATIVE</option>
                        </select>
                      </div>
                      <div>
                        <b>Query :</b>
                        <textarea
                          v-if="index === activeItem"
                          width="25px"
                          v-model="counter.query"
                          name="story"
                        ></textarea>
                        <span v-if="index != activeItem">{{
                          counter.query
                        }}</span>
                      </div>
                      <div v-if="counter.type == 'LIMITATIVE'">
                        <b>Limit : </b>
                        <span v-if="index != activeItem"
                          >&nbsp;{{ counter.limit }}</span
                        >
                        <input
                          v-if="index === activeItem"
                          type="number"
                          v-model="counter.limit"
                        />
                      </div>
                      <div v-if="!counter.err">
                        <b>Current Value :</b>
                        <span v-if="index != activeItem"
                          >&nbsp;{{ counter.value }}</span
                        >
                        <input
                          v-if="index === activeItem"
                          type="number"
                          v-model="counter.value"
                        />
                      </div>
                      <div v-else>
                        {{ counter.err }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="addcounter">
              <div style="width:97%;">
                <h3 class="customtitle">
                  Gestion des compteurs
                  <i v-on:click="nextStep(0)" class="fas fa-save savestep"></i>
                </h3>
              </div>
              <div class="elem">
                <label>Type de compteur</label>
                <multiselect
                  v-model="newCounter.type"
                  id="newCounter.type"
                  :options="['LIMITATIVE', 'INFORMATIVE']"
                  :multiple="false"
                  v-validate="'required'"
                  :searchable="false"
                  name="type"
                  placeholder="Type de compteur"
                  select-label="Cliquez pour ajouter"
                  deselect-label="Cliquez pour supprimer"
                ></multiselect>
              </div>
              <div class="elem">
                <label>Type de comptage</label>
                <select style="width:100%;margin:0 auto;" v-model="newCounter.increment">
                  <option value="false">Decrement</option>
                  <option value="true">Increment</option>                  
                </select>
              </div>              
              <div class="elem" v-if="newCounter.type == 'LIMITATIVE'">
                <label>Limite</label>
                <input
                  type="number"
                  name="newCounter.limit"
                  id="newCounter.limit"
                  v-model.number="newCounter.limit"
                />
              </div>
              <div class="elem">
                <label>Nom</label>
                <input
                  v-validate="'required'"
                  type="text"
                  name="newCounter.name"
                  id="newCounter.name"
                  v-model="newCounter.name"
                />
              </div>
              <div class="elem">
                <label>Query</label>
                <textarea
                  name="newCounter.query"
                  id="newCounter.query"
                  v-model="newCounter.query"
                ></textarea>
              </div>
              <br />
              <button class="btn-blue" type="button" @click="addCounter()">
                <i class="fa fa-plus"></i> Ajouter le compteur
              </button>
            </div>

            <div class="elem">
              <label>Texte quota atteint (html ok) </label>
              <textarea
                id="text_quotafull"
                name="text_quotafull"
                v-model="custom.text_quotafull"
                data-vv-scope="step6"
                placeholder="Ajouter un texte"
              ></textarea>
            </div>
          </div>
          <div class="step-contenair" v-if="step == 9">
            <h3 class="customtitle">
              Type d' ODR
              <i v-on:click="nextStep()" class="fas fa-save savestep"></i>
            </h3>

            <div class="elem">
              <label for="notions">BUDGET ODR (EN EUROS)&nbsp;</label>
              <input
                type="number"
                id="budget"
                name="budget"
                v-model="form.budget"
                data-vv-scope="step1"
                placeholder="Ex 200000"
              />
              <div class="error">{{ errors.first("step1.budget") }}</div>
            </div>
            <div class="odr_selections">
              <h2>ODR SIMPLE SUR L'ACHAT D'UN PRODUIT</h2>
              <ul>
                <li>
                  <input
                    type="radio"
                    v-model="odr_options.type"
                    id="ODR_SIMPLE_EUR"
                    name="drone"
                    value="ODR_SIMPLE_EUR"
                  />
                  <label for="ODR_SIMPLE_EUR">X€ remboursés</label>
                </li>
                <li v-if="odr_options.type === 'ODR_SIMPLE_EUR'">
                  <div class="elem">
                    <input
                      type="number"
                      v-model.number="
                        odr_options.datas['ODR_SIMPLE_EUR'].refund_eur
                      "
                      placeholder="Prix en €"
                    />
                  </div>
                </li>
                <li>
                  <input
                    type="radio"
                    v-model="odr_options.type"
                    id="ODR_SIMPLE_PERCENT"
                    name="drone"
                    value="ODR_SIMPLE_PERCENT"
                  />
                  <label for="ODR_SIMPLE_PERCENT">X% remboursés</label>
                </li>
                <li v-if="odr_options.type === 'ODR_SIMPLE_PERCENT'">
                  <div class="elem">
                    <input
                      placeholder="%"
                      v-model.number="
                        odr_options.datas['ODR_SIMPLE_PERCENT'].refund_percent
                      "
                      type="number"
                    /><br /><br />
                    <div style="margin-top:10px;">
                      Montant Max : &nbsp;<input
                        placeholder="En centimes"
                        v-model.number="
                          odr_options.datas['ODR_SIMPLE_PERCENT'].max
                        "
                        type="number"
                        style="width:50%;"
                      />
                    </div>
                  </div>
                </li>
                <li>
                  <input
                    type="radio"
                    v-model="odr_options.type"
                    id="ODR_EUR_PAR_PRODUIT"
                    name="drone"
                    value="ODR_EUR_PAR_PRODUIT"
                  />
                  <label for="ODR_EUR_PAR_PRODUIT"
                    >X€ remboursés par produit</label
                  >
                </li>
                <li
                  class="odr_palier"
                  v-if="odr_options.type === 'ODR_EUR_PAR_PRODUIT'"
                >
                  <div v-if="!JSONEditorActivated[0]">
                    <div
                      v-for="item in odr_options.datas['ODR_EUR_PAR_PRODUIT']
                        .price_list"
                      :key="item.key"
                    >
                      <div class="elem" style="width:100%">
                        <input
                          type="text"
                          style="width:120px; margin-right:20px;"
                          v-model="item.produit"
                          placeholder="Produit/EAN"
                        />
                        <input
                          type="number"
                          style="width:120px"
                          v-model.number="item.valeur"
                          placeholder="Valeur en €"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="container" v-else>
                    <JSONEditor
                      v-model="
                        odr_options.datas['ODR_EUR_PAR_PRODUIT'].price_list
                      "
                    ></JSONEditor>
                  </div>
                </li>

                <li>
                  <input
                    type="radio"
                    v-model="odr_options.type"
                    id="ODR_PERCENT_PAR_PRODUIT"
                    name="drone"
                    value="ODR_PERCENT_PAR_PRODUIT"
                  />
                  <label for="ODR_PERCENT_PAR_PRODUIT"
                    >X% remboursés par produit</label
                  >
                </li>
                <li
                  class="odr_palier"
                  v-if="odr_options.type === 'ODR_PERCENT_PAR_PRODUIT'"
                >
                  <div v-if="!JSONEditorActivated[0]">
                    <div
                      v-for="item in odr_options.datas[
                        'ODR_PERCENT_PAR_PRODUIT'
                      ].price_list"
                      :key="item.key"
                    >
                      <div class="elem" style="width:100%">
                        <input
                          type="text"
                          style="width:120px; margin-right:20px;"
                          v-model="item.produit"
                          placeholder="Produit/EAN"
                        />
                        <input
                          type="number"
                          style="width:120px"
                          v-model.number="item.valeur"
                          placeholder="Valeur en %"
                        />
                        <input
                          type="number"
                          style="width:190px;margin-left:20px;"
                          v-model.number="item.max"
                          placeholder="Valeur max en centimes"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="container" v-else>
                    <JSONEditor
                      v-model="
                        odr_options.datas['ODR_PERCENT_PAR_PRODUIT'].price_list
                      "
                    ></JSONEditor>
                  </div>

                  <div class="addordelete_palier">
                    <button
                      type="button"
                      v-if="!JSONEditorActivated[0]"
                      @click="toggleJSONEditor(0)"
                    >
                      JSON
                    </button>
                    <button type="button" v-else @click="toggleJSONEditor(0)">
                      FORM</button
                    >&nbsp;&nbsp;&nbsp;

                    <button
                      v-if="!JSONEditorActivated[0]"
                      v-on:click="addOdrPrds('ODR_PERCENT_PAR_PRODUIT')"
                    >
                      Ajouter
                    </button>
                    &nbsp; &nbsp;
                    <button
                      v-if="
                        odr_options.datas['ODR_PERCENT_PAR_PRODUIT'].price_list
                          .length > 1 && !JSONEditorActivated[0]
                      "
                      @click="delOdrPrds('ODR_PERCENT_PAR_PRODUIT')"
                    >
                      Retirer
                    </button>
                  </div>
                </li>
              </ul>

              <h2>ODR LIÉE À PLUSIEURS ACHATS</h2>
              <ul>
                <li>
                  <input
                    type="radio"
                    v-model="odr_options.type"
                    id="ODR_DOUBLE_EUR_MIN"
                    name="drone"
                    value="ODR_DOUBLE_EUR_MIN"
                  />
                  <label for="ODR_DOUBLE_EUR_MIN"
                    >2 produits achetés = X% sur le moins cher</label
                  >
                </li>
                <li v-if="odr_options.type === 'ODR_DOUBLE_EUR_MIN'">
                  <div class="elem">
                    <input
                      type="number"
                      v-model.number="
                        odr_options.datas['ODR_DOUBLE_EUR_MIN'].refund_percent
                      "
                      placeholder="%"
                    />
                    <br />
                    <input
                      type="number"
                      v-model.number="
                        odr_options.datas['ODR_DOUBLE_EUR_MIN'].max
                      "
                      placeholder="Montant maximum en centimes"
                    />
                  </div>
                </li>
                <li>
                  <input
                    type="radio"
                    v-model="odr_options.type"
                    id="ODR_DOUBLE_PRODUIT2_EUR"
                    name="drone"
                    value="ODR_DOUBLE_PRODUIT2_EUR"
                  />
                  <label for="ODR_DOUBLE_PRODUIT2_EUR"
                    >1 produit de la gamme A + 1 produit de la gamme B acheté =>
                    X€ sur le prix du produit de la gamme B</label
                  >
                </li>

                <li v-if="odr_options.type === 'ODR_DOUBLE_PRODUIT2_EUR'">
                  <div class="elem">
                    <textarea
                      v-model="
                        odr_options.datas['ODR_DOUBLE_PRODUIT2_EUR'].gamme_A
                      "
                      placeholder="Valeurs gamme A"
                    ></textarea>
                  </div>
                </li>

                <li v-if="odr_options.type === 'ODR_DOUBLE_PRODUIT2_EUR'">
                  <div class="elem">
                    <textarea
                      v-model="
                        odr_options.datas['ODR_DOUBLE_PRODUIT2_EUR'].gamme_B
                      "
                      placeholder="Valeurs gamme B"
                    ></textarea>
                  </div>
                </li>

                <li v-if="odr_options.type === 'ODR_DOUBLE_PRODUIT2_EUR'">
                  <div class="elem">
                    <input
                      type="number"
                      v-model.number="
                        odr_options.datas['ODR_DOUBLE_PRODUIT2_EUR'].refund_eur
                      "
                      placeholder="Prix en €"
                    />
                  </div>
                </li>

                <li>
                  <input
                    type="radio"
                    v-model="odr_options.type"
                    id="ODR_DOUBLE_PRODUIT2_PERCENT"
                    name="drone"
                    value="ODR_DOUBLE_PRODUIT2_PERCENT"
                  />
                  <label for="ODR_DOUBLE_PRODUIT2_PERCENT"
                    >1 produit de la gamme A + 1 produit de la gamme B acheté =>
                    X% sur le prix du produit de la gamme B</label
                  >
                </li>

                <li v-if="odr_options.type === 'ODR_DOUBLE_PRODUIT2_PERCENT'">
                  <div class="elem">
                    <textarea
                      v-model="
                        odr_options.datas['ODR_DOUBLE_PRODUIT2_PERCENT'].gamme_A
                      "
                      placeholder="Valeurs gamme A"
                    ></textarea>
                  </div>
                </li>

                <li v-if="odr_options.type === 'ODR_DOUBLE_PRODUIT2_PERCENT'">
                  <div class="elem">
                    <textarea
                      v-model="
                        odr_options.datas['ODR_DOUBLE_PRODUIT2_PERCENT'].gamme_B
                      "
                      placeholder="Valeurs gamme B"
                    ></textarea>
                  </div>
                </li>

                <li v-if="odr_options.type === 'ODR_DOUBLE_PRODUIT2_PERCENT'">
                  <div class="elem">
                    <input
                      type="number"
                      v-model.number="
                        odr_options.datas['ODR_DOUBLE_PRODUIT2_PERCENT']
                          .refund_percent
                      "
                      placeholder="%"
                    /><br />
                    <div
                      style="display:flex;align-items:center;margin-top:10px;"
                    >
                      <span>Montant&nbsp;maximum&nbsp;:</span>&nbsp;
                      <input
                        style="width:50%"
                        type="number"
                        v-model.number="
                          odr_options.datas['ODR_DOUBLE_PRODUIT2_PERCENT'].max
                        "
                        placeholder="En centimes"
                      />
                    </div>
                  </div>
                </li>

                <li>
                  <input
                    type="radio"
                    v-model="odr_options.type"
                    id="ODR_DOUBLE_PERCENT"
                    name="drone"
                    value="ODR_DOUBLE_PERCENT"
                  />
                  <label for="ODR_DOUBLE_PERCENT"
                    >1 produit de la gamme A + 1 produit de la gamme B acheté =>
                    X% sur la somme de 2 produits achetés</label
                  >
                </li>
                <li v-if="odr_options.type === 'ODR_DOUBLE_PERCENT'">
                  <div class="elem">
                    <textarea
                      v-model="odr_options.datas['ODR_DOUBLE_PERCENT'].gamme_A"
                      placeholder="Valeurs gamme A"
                    ></textarea>
                  </div>
                </li>

                <li v-if="odr_options.type === 'ODR_DOUBLE_PERCENT'">
                  <div class="elem">
                    <textarea
                      v-model="odr_options.datas['ODR_DOUBLE_PERCENT'].gamme_B"
                      placeholder="Valeurs gamme B"
                    ></textarea>
                  </div>
                </li>

                <li v-if="odr_options.type === 'ODR_DOUBLE_PERCENT'">
                  <div class="elem">
                    <input
                      type="number"
                      v-model.number="
                        odr_options.datas['ODR_DOUBLE_PERCENT'].refund_percent
                      "
                      placeholder="%"
                    /><br />
                    <div
                      style="display:flex;align-items:center;margin-top:10px;"
                    >
                      <span>Montant&nbsp;maximum&nbsp;:</span>&nbsp;
                      <input
                        style="width:50%"
                        type="number"
                        v-model.number="
                          odr_options.datas['ODR_DOUBLE_PERCENT'].max
                        "
                        placeholder="En centimes"
                      />
                    </div>
                  </div>
                </li>
                <li>
                  <input
                    type="radio"
                    v-model="odr_options.type"
                    id="ODR_DOUBLE_EUR"
                    name="drone"
                    value="ODR_DOUBLE_EUR"
                  />
                  <label for="ODR_DOUBLE_EUR"
                    >2 produits achetés = X% sur la valeur globale</label
                  >
                </li>
                <li v-if="odr_options.type === 'ODR_DOUBLE_EUR'">
                  <div class="elem">
                    <input
                      type="number"
                      v-model.number="
                        odr_options.datas['ODR_DOUBLE_EUR'].refund_percent
                      "
                      placeholder="%"
                    /><br />
                    <div
                      style="display:flex;align-items:center;margin-top:10px;"
                    >
                      Montant maximum :
                      <input
                        style="width:50%;"
                        type="number"
                        v-model.number="odr_options.datas['ODR_DOUBLE_EUR'].max"
                        placeholder="En centimes"
                      />
                    </div>
                  </div>
                </li>
                <li>
                  <input
                    type="radio"
                    v-model="odr_options.type"
                    id="ODR_PRIX_PRODUIT_MONTANT_TOTAL_MIN_PALIER"
                    name="drone"
                    value="ODR_PRIX_PRODUIT_MONTANT_TOTAL_MIN_PALIER"
                  />
                  <label for="ODR_PRIX_PRODUIT_MONTANT_TOTAL_MIN_PALIER"
                    >Liste de produits à acheter = X€ par palier</label
                  >
                </li>
                <li
                  class="odr_palier"
                  v-if="
                    odr_options.type ===
                      'ODR_PRIX_PRODUIT_MONTANT_TOTAL_MIN_PALIER'
                  "
                >
                  <div
                    v-for="item in odr_options.datas[
                      'ODR_PRIX_PRODUIT_MONTANT_TOTAL_MIN_PALIER'
                    ].price_list"
                    :key="item.key"
                  >
                    <div class="elem" style="width:100%">
                      <input
                        type="number"
                        style="width:100px; margin-right:20px;"
                        v-model.number="item.palier"
                        placeholder="Palier"
                      />
                      <input
                        type="number"
                        style="width:100px"
                        v-model.number="item.valeur"
                        placeholder="Valeur"
                      />
                    </div>
                  </div>
                  <div class="addordelete_palier">
                    <button
                      v-if="
                        odr_options.datas[
                          'ODR_PRIX_PRODUIT_MONTANT_TOTAL_MIN_PALIER'
                        ].price_list.length < 5
                      "
                      v-on:click="
                        addOdrPrds('ODR_PRIX_PRODUIT_MONTANT_TOTAL_MIN_PALIER')
                      "
                    >
                      Ajouter
                    </button>
                    &nbsp; &nbsp;
                    <button
                      v-if="
                        odr_options.datas[
                          'ODR_PRIX_PRODUIT_MONTANT_TOTAL_MIN_PALIER'
                        ].price_list.length > 1
                      "
                      @click="
                        delOdrPrds('ODR_PRIX_PRODUIT_MONTANT_TOTAL_MIN_PALIER')
                      "
                    >
                      Retirer
                    </button>
                  </div>
                </li>
              </ul>
              <h2>ODR CONVERTIBLE</h2>
              <ul>
                <li>
                  <input
                    type="radio"
                    v-model="odr_options.type"
                    id="ODR_CHOIX_EUR"
                    name="drone"
                    value="ODR_CHOIX_EUR"
                  />
                  <label for="ODR_CHOIX_EUR">X€ remboursé ou 1 cadeau</label>
                </li>
                <li v-if="odr_options.type === 'ODR_CHOIX_EUR'">
                  <div class="elem">
                    <input
                      type="text"
                      v-model="
                        odr_options.datas['ODR_CHOIX_EUR'].refund_condition
                      "
                      placeholder="IF (placeholder submission.question_1 == remboursement )"
                    />
                  </div>
                </li>

                <li v-if="odr_options.type === 'ODR_CHOIX_EUR'">
                  <div class="elem">
                    <input
                      type="number"
                      v-model.number="
                        odr_options.datas['ODR_CHOIX_EUR'].refund_percent
                      "
                      placeholder="%"
                    />
                    <br />
                    <div
                      style="display:flex;align-items:center;margin-top:10px;"
                    >
                      Montant maximum :
                      <input
                        type="number"
                        style="width:50%;"
                        v-model.number="odr_options.datas['ODR_CHOIX_EUR'].max"
                        placeholder="En centimes"
                      />
                    </div>
                  </div>
                </li>
              </ul>
              <h2>AUTRE</h2>
              <ul>
                <li>
                  <input
                    type="radio"
                    v-model="odr_options.type"
                    id="ODR_CUSTOM"
                    name="drone"
                    value="ODR_CUSTOM"
                  />
                  <label for="ODR_CUSTOM">ODR Custom</label>
                </li>
                <li v-if="odr_options.type === 'ODR_CUSTOM'">
                  <div class="elem">
                    <textarea
                      v-model="odr_options.datas['ODR_CUSTOM'].code_js"
                      placeholder="code JS"
                    ></textarea>
                  </div>
                </li>
              </ul>
            </div>
            <div class="button_wrap">
              <br />
              <button class="btn-blue" type="button" v-on:click="nextStep()">
                <i class="fa fa-save"></i> Sauvegarder
              </button>
            </div>
          </div>
          <div class="contenair homeop" v-if="step == 10">
            <Data/>
          </div>
          <div class="contenair homeop" v-if="step == 11">
            <DataList :_id="$route.params._id" :form="form" />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import DataList from "@/views/DataList";
import MenuOperation from "../components/MenuOperation";
import Data from "@/views/Data";
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.css";
import Multiselect from "vue-multiselect";
import Vue from "vue";
import VueDatepickerLocal from "vue-datepicker-local";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import JSONEditor from "../components/JSONEditor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor, Quill } from "vue-quill-editor";
import Verte from "verte";
import "verte/dist/verte.css";
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles somewhere
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-tomorrow.css"; // import syntax highlighting styles
import { downloadBlob } from '../utils'
import auth from '../auth'

// register component globally
Vue.component(Verte.name, Verte);
let AlignClass = Quill.import("attributors/style/align");
Quill.register(AlignClass, true);

let BackgroundStyle = Quill.import("attributors/style/background");
Quill.register(BackgroundStyle, true);

let DirectionStyle = Quill.import("attributors/style/direction");
Quill.register(DirectionStyle, true);

let FontStyle = Quill.import("attributors/style/font");
Quill.register(FontStyle, true);

let SizeStyle = Quill.import("attributors/style/size");
SizeStyle.whitelist = ["0.8rem", "1rem", "1.5rem", "2rem", "2.6rem"];
Quill.register(SizeStyle, true);

var Block = Quill.import("blots/block");
Block.tagName = "DIV";
Quill.register(Block, true);

const Embed = Quill.import("blots/embed");

Quill.register(
  class extends Embed {
    static create(key) {
      let node = super.create();
      node.setAttribute("contenteditable", true);
      node.setAttribute("class", "headerlogo");
      node.innerHTML = `${key}`;
      return node;
    }
    static value(node) {
      return node.dataset.key;
    }

    static blotName = "customEmbed";
    static className = "customEmbed";
    static tagName = "div";
  }
);

import moment from "moment";
Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY hh:mm");
  }
});
const motif_nc_list = {
  MISSING: [
    "Vous n'avez pas téléchargé la photo de votre ticket de caisse / facture d'achat",
    "Vous n'avez pas téléchargé la photo de votre(vos) code(s)-barres",
    "La(les) référence(s) de votre(vos) produit(s) éligible(s) n'apparraît(aissent) pas sur votre preuve d'achat",
    "Le(es) prix de de votre(vos) produit(s) éligible(s) n'apparraît(aissent) pas sur votre preuve d'achat",
    "Vous n'avez pas téléchargés votre relevé IBAN BIC",
    "Certaines informations nécessaires au traitement de votre dossier son manquante",
    "Autre",
  ],
  INVALID: [
    "Vous avez déjà participé à cette opération (offre limité, voir modalités)",
    "Vous avez déjà gagné avec les éléments de dossier transmis (offre limité, voir modalités)",
    "Vous n'avez pas acheté votre(vos) produit(s) pendant les dates de l'opération (voir modalités)",
    "Vous n'avez pas acheté votre(vos) produit(s) dans une enseigne ou un distributeur éligible à l'opération (voir modalités)",
    "Le(les) produit(s) que vous avez acheté(s) n'est(ne sont) pas éligible(s) à l'opération (voir modalités)",
    "Le nombre maximum de participants a été atteint (offre limité, voir modalités)",
    "Autre",
  ],
  UNREADABLE: [
    "La photo du ticket de caisse ou de la facture d'achat que vous avez téléchargé est illisible.",
    "La référence de votre(vos) produit(s) est(sont) illisible(s)",
    "Le(les) prix d'achat de votre(vos) produit(s) est(sont) illisible(s) ou manquant(s)",
    "L'enseigne dans laquelle vous avez acheté votre(vos) produit(s) n'est pas identifiable",
    "La date d'achat sur votre ticket de caisse ou facture est illisible ou n'est pas identifiable",
    "Certaines informations nécessaires au traitement de votre dossier sont illisible",
    "Autre",
  ],
};
export default {
  name: "home",
  data: function() {
    return {
      userinfos : auth.getUserInfos(),
      regule: [],
      destinataire: "thierry.noel@promo.dev",
      sujetEmail: "",
      templateID: "",
      emailView: false,
      envList2: ["GABARIT ODR", "PERSONNALISER"],
      statusList: [true, false],
      htmlview: [],
      typebackground: "default",
      we_links: "",
      emailType: "",
      openRegule: false,
      openmail: false,
      emailcontent: undefined,
      emailList: undefined,
      emailIndex: undefined,
      editorOptionGabarit: {
        modules: {
          syntax: false,
          clipboard: {
            matchVisual: false,
          },
          toolbar: {
            container: [
              [{ size: SizeStyle.whitelist }],
              ["bold", "italic", "underline"],
              [
                {
                  color: [
                    "#000000",
                    "#e60000",
                    "#ff9900",
                    "#ffff00",
                    "#008a00",
                    "#0066cc",
                    "#9933ff",
                    "#ffffff",
                    "#facccc",
                    "#ffebcc",
                    "#ffffcc",
                    "#cce8cc",
                    "#cce0f5",
                    "#ebd6ff",
                    "#bbbbbb",
                    "#f06666",
                    "#ffc266",
                    "#ffff66",
                    "#66b966",
                    "#66a3e0",
                    "#c285ff",
                    "#888888",
                    "#a10000",
                    "#b26b00",
                    "#b2b200",
                    "#006100",
                    "#0047b2",
                    "#6b24b2",
                    "#444444",
                    "#5c0000",
                    "#663d00",
                    "#666600",
                    "#003700",
                    "#002966",
                    "#3d1466",
                    "custom-color",
                  ],
                },
              ],
              [{ align: [] }],
              ["link"],
              ["clean"],
            ],
            handlers: {
              color: function(value) {
                if (value == "custom-color") {
                  value = prompt("Enter Hex/RGB/RGBA");
                }
                this.quill.format("color", value);
              },
            },
          },
        },
      },
      editorOption: {
        modules: {
          syntax: false,
          toolbar: {
            container: [
              [{ font: [] }, { size: SizeStyle.whitelist }],
              ["bold", "italic", "underline"],
              [
                {
                  color: [
                    "#000000",
                    "#e60000",
                    "#ff9900",
                    "#ffff00",
                    "#008a00",
                    "#0066cc",
                    "#9933ff",
                    "#ffffff",
                    "#facccc",
                    "#ffebcc",
                    "#ffffcc",
                    "#cce8cc",
                    "#cce0f5",
                    "#ebd6ff",
                    "#bbbbbb",
                    "#f06666",
                    "#ffc266",
                    "#ffff66",
                    "#66b966",
                    "#66a3e0",
                    "#c285ff",
                    "#888888",
                    "#a10000",
                    "#b26b00",
                    "#b2b200",
                    "#006100",
                    "#0047b2",
                    "#6b24b2",
                    "#444444",
                    "#5c0000",
                    "#663d00",
                    "#666600",
                    "#003700",
                    "#002966",
                    "#3d1466",
                    "custom-color",
                  ],
                },
              ],
              ["direction", { align: [] }],
              ["link", "image"],
              [
                {
                  placeholder: [
                    "[first_name]",
                    "[last_name]",
                    "[libelle]",
                    "[societe]",
                    "[lot_description]",
                    "[lot_img]",
                    "[logo_uri]",
                    "[email]",
                    "[id]",
                    "[uid]",
                    "[codelot]",
                    "[motif_nc]",
                  ],
                },
              ],
              ["clean"],
            ],
            handlers: {
              placeholder: function(value) {
                if (value) {
                  const cursorPosition = this.quill.getSelection().index;
                  this.quill.insertText(cursorPosition, value);
                  this.quill.setSelection(cursorPosition + value.length);
                }
              },
              color: function(value) {
                if (value == "custom-color") {
                  value = prompt("Enter Hex/RGB/RGBA");
                }
                this.quill.format("color", value);
              },
            },
          },
        },
      },
      JSONEditorActivated: {},
      formId: undefined,
      activeItem: null,
      showButtons: true,
      clearable: true,
      customeSelected: "A",
      filename: undefined,
      formulaires: [],
      newForm: {
        type: "CREATE",
        description: "",
      },
      range: [new Date(), new Date()],
      local: {
        dow: 0, // Sunday is the first day of the week
        // hourTip: 'Heure', // tip of select hour
        // minuteTip: 'Minute', // tip of select minute
        // secondTip: 'Seconde', // tip of select second
        yearSuffix: "",
        monthsHead: "Janvier_Février_Mars_Avril_Mai_Juin_Juillet_Août_Septembre_Octobre_Novembre_Decembre".split(
          "_"
        ),
        months: "Jan_Fev_Mar_Avr_Mai_Jun_Jui_Août_Sept_Oct_Nov_Dec".split("_"),
        weeks: "Lun_Mar_Mer_Jeu_Ven_Sam_Dim".split("_"),
        cancelTip: "Quitter",
        submitTip: "Valider",
      },
      emailConfig: {
        email: undefined,
        name: undefined,
        mailjetAccount: "promodev",
      },
      odr_options: {
        type: undefined,
        datas: [[]],
      },
      custom: {
        pagetitle: undefined,
        home_btn_txt: undefined,
        links: [],
      },
      form: {
        title: undefined,
        owners: [],
        type: undefined,
        pays: undefined,
        description: undefined,
        mentionsLegales: undefined,
        contactezNous: undefined,
        notions: undefined,
        datastudio: undefined,
        date_debut: "1990/1/1",
        date_fin: "1990/1/1",
        date_fin_achat: "1990/1/1",
        date_delete_data: "2050/1/1",
        date_anonymisation_data: "2050/1/1",
        domaine: undefined,
        playerlimit: undefined,
        doublon: undefined,
        idgame: undefined,
        client: undefined,
        env: undefined,
        redirection_after_valid: undefined,
        ipUniq: false,
        recaptchaV3Public: undefined,
        recaptchaV3Private: undefined,
        files: [],
        pays: [],
        lang: undefined,
        email: {},
        custom: [],
        checkurl: undefined,
        checkbybot: undefined,
        zapierWebhook: undefined,
      },
      counters: {},
      newCounter: {},
      files: [],
      date: [],
      paysList: [
        { name: "de", label: "Allemagne" },
        { name: "fr", label: "France" },
        { name: "be-fr", label: "Belgique (FR)" },
        { name: "be-nl", label: "Belgique (NL)" },
        { name: "nl", label: "Pays-Bas" },
        { name: "pl", label: "Pologne" },
        { name: "es-es", label: "Espagne" },
        { name: "es-cat", label: "Espagne (Catalan)" },
        { name: "it", label: "Italie" },
        { name: "en", label: "Anglais" },
        { name: "lu-fr", label: "Luxembourg (FR)" },
        { name: "lu-nl", label: "Luxembourg (NL)" },
        { name: "ro", label: "Roumanie" },
        { name: "si", label: "Slovénie" },
        { name: "bg", label: "Bulgarie" },
        { name: "gr", label: "Grèce" },
        { name: "ar", label: "Tunisie" },
      ],
      ownersList: [
        { email: "herve.colard@gmail.com" },
        { email: "cyril.bareme@gmail.com" },
        { email: "nt@oxonegroup.fr " },
      ],
      typeList: ["JEU SOA", "JEU WEB", "ODR", "FORMULAIRE",  "JEU AVEC REMBOURSEMENT", "PRIME"],
      envList: ["TEST", "PROD"],
      serverList: ["DEFAULT"],
      animationsList: [
        "AUCUNE",
        "CARTE A GRATTER",
        "ROUE DE LA CHANCE",
        "BANDIT MANCHOT",
        "CANDYRUSH",
      ],
      doublonList: ["OUI", "NON"],
      emails: [],
      file: "",
      clientList: undefined,
      dnsCheck: {
        loading: true,
        domains: [],
        error: null,
      },
    };
  },
  components: {
    Data,
    MenuOperation,
    DataList,
    PrismEditor,
    quillEditor,
    Multiselect,
    VueDatepickerLocal,
    SweetModal,
    SweetModalTab,
    JSONEditor,
    VueTabs,
    VTab,
    Verte,
  },
  props: {
    step: {
      type: Number,
      default: null,
    },
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
    MISSING: {
      get() {
        if (
          this.form.motifsNC &&
          this.form.motifsNC.MISSING &&
          this.form.motifsNC.MISSING.length > 0
        ) {
          return this.form.motifsNC.MISSING.join("\n");
        } else {
          return motif_nc_list.MISSING.join("\n");
        }
      },
      set(val) {
        if (!this.form.motifsNC) {
          this.form.motifsNC = { MISSING: [] };
        }
        if (val.length == 0) {
          this.form.motifsNC.MISSING = [];
        } else {
          this.form.motifsNC.MISSING = val.split("\n");
        }
      },
    },
    UNREADABLE: {
      get() {
        if (
          this.form.motifsNC &&
          this.form.motifsNC.UNREADABLE &&
          this.form.motifsNC.UNREADABLE.length > 0
        ) {
          return this.form.motifsNC.UNREADABLE.join("\n");
        } else {
          return motif_nc_list.UNREADABLE.join("\n");
        }
      },
      set(val) {
        if (!this.form.motifsNC) {
          this.form.motifsNC = { UNREADABLE: [] };
        }
        if (val.length == 0) {
          this.form.motifsNC.UNREADABLE = [];
        } else {
          this.form.motifsNC.UNREADABLE = val.split("\n");
        }
      },
    },
    INVALID: {
      get() {
        if (
          this.form.motifsNC &&
          this.form.motifsNC.INVALID &&
          this.form.motifsNC.INVALID.length > 0
        ) {
          return this.form.motifsNC.INVALID.join("\n");
        } else {
          return motif_nc_list.INVALID.join("\n");
        }
      },
      set(val) {
        if (!this.form.motifsNC) {
          this.form.motifsNC = { INVALID: [] };
        }
        if (val.length == 0) {
          this.form.motifsNC.INVALID = [];
        } else {
          this.form.motifsNC.INVALID = val.split("\n");
        }
      },
    },
  },
  async mounted() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    try {
      this.clientList = await this.getUniqClient();
      console.log(this.clientList);
    } catch (e) {}
    this.custom.banner_disable_animation = String(
      this.custom.banner_disable_animation
    );
    this.custom.banner_disable_cookie = String(
      this.custom.banner_disable_cookie
    );  
    try {
      let links = await this.$axios.get("/api/wetransfer/list/");
      this.we_links = links.data.filter((link) => {
        return link.operationId === this.$route.params._id;
      });
    } catch (e) {
      console.log(e);
    }
    this.$axios.get("/api/v2/emailtemplates/list").then((response) => {
      this.emailList = response.data;
    });
    this.$axios
      .get("/api/operations/" + this.$route.params._id)
      .then((response) => {
        if (response.data.doublon) {
          response.data.doublon = "OUI";
        } else {
          response.data.doublon = "NON";
        }
        if (response.data.emails) {
          this.emails = response.data.emails;
        }
        if (response.data.custom) {
          this.custom = response.data.custom;
        } else {
          this.custom = {};
        }
        if (!this.custom.mobile_menu_position)
          this.custom.mobile_menu_position = "left";
        if (!this.custom.color_top_link) this.custom.color_top_link = "#000000";
        if (!this.custom.color_top_bg_link)
          this.custom.color_top_bg_link = "#FFFFFF";
        if (!this.custom.color_input_border)
          this.custom.color_input_border = "#ACC4D9";
        if (!this.custom.color_input_bg) this.custom.color_input_bg = "#FFFFFF";
        if (!this.custom.color_input_txt)
          this.custom.color_input_txt = "#000000";
        if (!this.custom.color_input_bg_focus)
          this.custom.color_input_bg_focus = "#F2F7F9";
        if (!this.custom.color_input_bg_error)
          this.custom.color_input_bg_error = "#FFFFFF";
        if (!this.custom.color_error_txt)
          this.custom.color_error_txt = "#F12137";
        if (!this.custom.color_bg_button_back)
          this.custom.color_bg_button_back = "#ACC4D9";
        if (!this.custom.color_text_button_back)
          this.custom.color_text_button_back = "#000000";
        if (!this.custom.primary_color_bg)
          this.custom.primary_color_bg = "#FFFFFF";
        if (!this.custom.primary_color_txt)
          this.custom.primary_color_txt = "#000000";
        if (!this.custom.secondary_color_bg)
          this.custom.secondary_color_bg = "#EC520D";
        if (!this.custom.secondary_color_txt)
          this.custom.secondary_color_txt = "#FFFFFF";
        if (!this.custom.font_size) this.custom.font_size = "16";
        if (!this.custom.banner_disable_cookie)
          this.custom.banner_disable_cookie = true;
        if (!this.custom.home_btn_txt)
          this.custom.home_btn_txt = "Je participe";
        if (!this.custom.transparence_nav_link)
          this.custom.transparence_nav_link = 0;
        if (!this.custom.banner_disable_animation)
          this.custom.banner_disable_animation = false;
          if (!this.custom.banner_disable_cookie)
          this.custom.banner_disable_cookie = false;        
        if (!this.custom.typebackground) this.custom.typebackground = "default";
        if (!this.custom.font_family) this.custom.font_family = "Roboto";
        if (!this.custom.links || this.custom.links.length == 0) {
          this.custom.links = [
            { label: "", link: "" },
            { label: "", link: "" },
          ];
        } else if (this.custom.links.length === 1) {
          this.custom.links.push({ label: "", link: "" });
        }
        if (response.data.emailConfig) {
          this.emailConfig = response.data.emailConfig;
        }
        this.files = response.data.files;
        this.form = response.data;
        this.setODRoptions();
      })
      .catch((error) => {
        console.log(error);
        this.$router.push("/?error");
      });
    this.$axios.get("/api/users/list").then((response) => {
      this.ownersList = response.data;
    });
    this.$axios
      .get("/api/v2/formulaires/operation/" + this.$route.params._id)
      .then((response) => {
        this.formulaires = response.data;
      });
    this.loadCounter();
    this.checkDns();
  },
  methods: {
     async updateDomains() {
      if (this.form.domaine) {
        var url = this.form.domaine;
        this.form.domaine = url.replace(/^https?:\/\//, '');
      }
      if(this.form.domaine_dev) {
        var url2 = this.form.domaine_dev;
        this.form.domaine_dev = url2.replace(/^https?:\/\//, '');        
      }
    },   
     async checkDns() {
      this.dnsCheck.loading = true;
      this.dnsCheck.error = null;
      try {
        const { data } = await this.$axios.get("/api/operations/" + this.$route.params._id + "/dns")
        this.dnsCheck.domains = Object.entries(data).map(([k, v]) => ({
          title: k,
          success: v.status === 'OK',
          code: v.code,
        }))
      } catch (e) {
        this.dnsCheck.error = e.message;
      }
      this.dnsCheck.loading = false;
    },   
    async saveSubmission() {

      if(this.formulaires && this.formulaires.length) {

          var create = this.formulaires.filter(function(form) {
            return form.type === "CREATE";
          });

          if(!create) {
            alert('AUCUN FORMULAIRE CREATE')
            return false;
          }
          this.regule.formulaireId = create[0]._id,
          this.regule.date = new Date()
          this.regule.participationValide = "VALID";
          this.regule.status = "REGUL";
          this.regule.operationId = this.$route.params._id;
          this.regule.ip = "0.0.0.0";


          console.log(this.regule)

          try {
            let addSub = await this.$axios.post(
              "/api/v2/submissions/regule/" + this.$route.params._id,
              {
                ...this.regule,
              }
            );
            console.log(addSub);
            this.openRegule = false;
            this.regule = [];

            this.$swal({
              position: "top-end",
              type: "success",
              title: "Submission sauvegardée",
              showConfirmButton: false,
              timer: 1500,
            });
          } catch (e) {
            console.log(e);
          }

      } else {
          alert('AUCUN FORMULAIRE CREATE')
          return false;
      }

    },
    highlighter(code) {
      return highlight(code, languages.js); //returns html
    },
    ifUploaded(filename) {
      if (this.files) {
        var filtered_matching = this.files.filter((s) =>
          s.filename.includes(filename)
        );
        if (filtered_matching.length > 0) {
          return filtered_matching[0].uri;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    toogleViewcode(i) {
      Vue.set(this.htmlview, i, !this.htmlview[i]);
    },
    async cloneForm(form) {
      try {
        this.$swal
          .mixin({
            input: "text",
            confirmButtonText: "Dupliquer",
            showCancelButton: true,
            inputValidator: (value) => {
              return !value && "Champ obligatoire !";
            },
          })
          .queue([
            {
              title: "Dupliquer ce formulaire ?",
              text: "Merci de coller la clé api de l'opération",
            },
          ])
          .then(async (result) => {
            if (result.value != "" && result.value) {
              let { data } = await this.$axios.get(
                `/api/v2/formulaires/${form._id}`
              );
              delete data.formulaire._id;
              data.formulaire.operationId = result.value;
              let addform = await this.$axios.post(
                "/api/v2/formulaires/" + result.value,
                {
                  type: form.type,
                  description: form.description,
                  lang: form.lang,
                }
              );
              if (addform.data._id) {
                let result = await this.$axios.put(
                  "/api/v2/formulaires/" + addform.data._id,
                  { ...data.formulaire }
                );
              }
            }
          });
      } catch (e) {}
    },
    toggleJSONEditor(index) {
      Vue.set(
        this.JSONEditorActivated,
        index,
        !this.JSONEditorActivated[index]
      );
    },
    async downloadCdctoxml(id, name) {
      const res = await this.$axios.get(`/api/v2/cdctoxml/${id}`, {
        responseType: "blob",
      });
      downloadBlob(`${name}.xlsx`, res.data);
    },
    addOdrPrds(field) {
      event.preventDefault();
      this.odr_options.type = false;
      if (
        field === "ODR_EUR_PAR_PRODUIT" ||
        field === "ODR_PERCENT_PAR_PRODUIT"
      ) {
        this.odr_options.datas[field].price_list.push({
          produit: "",
          valeur: "",
        });
      } else {
        this.odr_options.datas[field].price_list.push({
          palier: "",
          valeur: "",
        });
      }
      this.odr_options.type = field;
    },
    delOdrPrds(field) {
      event.preventDefault();
      this.odr_options.type = false;
      var ttl = this.odr_options.datas[field].price_list.length;
      if (ttl > 1) {
        this.odr_options.datas[field].price_list.pop();
      }
      this.odr_options.type = field;
    },
    setODRoptions() {
      this.odr_options.datas["ODR_SIMPLE_EUR"] = {};
      this.odr_options.datas["ODR_SIMPLE_PERCENT"] = {};
      this.odr_options.datas["ODR_DOUBLE_EUR_MIN"] = {};
      this.odr_options.datas["ODR_DOUBLE_PRODUIT2_EUR"] = {};
      this.odr_options.datas["ODR_DOUBLE_PRODUIT2_PERCENT"] = {};
      this.odr_options.datas["ODR_DOUBLE_PERCENT"] = {};
      this.odr_options.datas["ODR_CHOIX_EUR"] = {};
      this.odr_options.datas["ODR_CUSTOM"] = {};
      this.odr_options.datas["ODR_DOUBLE_EUR"] = {};
      this.odr_options.datas["ODR_PRIX_PRODUIT_MONTANT_TOTAL_MIN_PALIER"] = {};
      this.odr_options.datas[
        "ODR_PRIX_PRODUIT_MONTANT_TOTAL_MIN_PALIER"
      ].price_list = [{ palier: "", valeur: "" }];
      this.odr_options.datas["ODR_EUR_PAR_PRODUIT"] = {};
      this.odr_options.datas["ODR_EUR_PAR_PRODUIT"].price_list = [
        { produit: "", valeur: "" },
      ];
      this.odr_options.datas["ODR_PERCENT_PAR_PRODUIT"] = {};
      this.odr_options.datas["ODR_PERCENT_PAR_PRODUIT"].price_list = [
        { produit: "", valeur: "" },
      ];
      if (this.form.odr_options) {
        this.odr_options.type = this.form.odr_options.type;
        if (this.form.odr_options.refund_eur)
          this.odr_options.datas[
            this.odr_options.type
          ].refund_eur = this.form.odr_options.refund_eur;
        if (this.form.odr_options.refund_percent)
          this.odr_options.datas[
            this.odr_options.type
          ].refund_percent = this.form.odr_options.refund_percent;
        if (this.form.odr_options.max)
          this.odr_options.datas[
            this.odr_options.type
          ].max = this.form.odr_options.max;
        if (this.form.odr_options.gamme_A)
          this.odr_options.datas[
            this.odr_options.type
          ].gamme_A = this.form.odr_options.gamme_A;
        if (this.form.odr_options.gamme_B)
          this.odr_options.datas[
            this.odr_options.type
          ].gamme_B = this.form.odr_options.gamme_B;
        if (this.form.odr_options.refund_condition)
          this.odr_options.datas[
            this.odr_options.type
          ].refund_condition = this.form.odr_options.refund_condition;
        if (this.form.odr_options.code_js) {
          this.odr_options.datas[
            this.odr_options.type
          ].code_js = this.form.odr_options.code_js;
        }
        if (this.form.odr_options.price_list)
          this.odr_options.datas[
            this.odr_options.type
          ].price_list = this.form.odr_options.price_list;
      }
    },
    clean(myArray) {
      myArray = myArray.filter(function(obj) {
        return obj.label != "";
      });
      return myArray;
    },
    onCopy: function(e) {
      this.$swal({
        position: "top-end",
        type: "success",
        title: e.text + " copié avec succès",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    loadCounter() {
      this.$axios
        .get("/api/v2/counters/" + this.$route.params._id)
        .then(async (response) => {
          this.counters = response.data;
          for (let i = 0; i < this.counters.length; i++) {
            try {
              let value = (await this.$axios.get(
                `/api/v2/counters/${this.$route.params._id}/${
                  this.counters[i].name
                }`
              )).data.value;
              Vue.set(this.counters[i], "value", value);
            } catch (err) {
              Vue.set(this.counters[i], "err", err.data);
            }
          }
        });
    },
    singleUpload(filename) {
      this.filename = filename;
      this.handleFileUpload(filename);
    },
    goToProd(url) {
      window.open("https://" + url.replace(/(^\w+:|^)\/\//, ""));
    },
    async getUniqClient() {
      this.$axios.get("/api/users/getUniqClient").then((response) => {
        this.clientList = response.data;
      });
    },
    selectItem(i) {
      this.activeItem = i;
    },
    addBannerEmail() {
      this.$refs.myQuillEditor.quill.clipboard.dangerouslyPasteHTML(
        0,
        "&nbsp;<b>World</b>"
      );
    },
    addLogoEmail() {
      this.$refs.myQuillEditor.quill.clipboard.dangerouslyPasteHTML(
        0,
        "&nbsp;<b>World</b>"
      );
    },
    addTagEmail(tag) {
      console.log(this.$refs.myQuillEditor.quill);
      this.$refs.myQuillEditor.quill.insertText(5, "Hello", "bold", true);
    },
    getMailHeader(type) {
      if (type === "logo") {
      } else if (type === "banniere") {
      }

      this.$refs.myQuillEditor.quill.insertEmbed(0, "customEmbed", "test");
    },
    async sendMail() {
      var logo = this.ifUploaded("logo1");
      var infos = [
        {
          email: this.emailcontent,
          logo: logo,
          primary_color_bg: this.custom.sprimary_color_bg,
          primary_color_txt: this.sprimary_color_txt,
          secondary_color_bg: this.custom.secondary_color_bg,
          secondary_color_txt: this.secondary_color_txt,
          operationId: this.$route.params._id,
          societe: this.form.societe,
          sujet: this.sujetEmail,
          templateID: this.templateID,
          destinataire: this.destinataire,
          operation_id: this.$route.params._id,
        },
      ];

      try {
        let result = await this.$axios.post("/api/sendmailtest/sendmail", {
          ...infos,
        });

        this.$swal({
          position: "top-end",
          type: "success",
          title: "Email Test Envoyé",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (e) {
        console.log(e);
      }
    },
    createForm() {
      if (!this.newForm.description || this.newForm.description === "") {
        this.newForm.description = this.newForm.type;
      }
      this.$axios
        .post("/api/v2/formulaires/" + this.$route.params._id, this.newForm)
        .then((response) => {
          this.formulaires.push(response.data);
        });
    },
    deleteForm(formId, index) {
      if (!confirm("Voulez vous supprimer le formulaire ?")) {
        return;
      }
      this.$axios.delete("/api/v2/formulaires/" + formId).then((response) => {
        this.formulaires.splice(index, 1);
      });
    },
    saveCounter: async function(index) {
      var response = await this.$axios.post(
        "/api/v2/counters/" + this.$route.params._id + "/update",
        this.counters
      );
      // this.counters = response.data
      this.loadCounter();
      this.activeItem = 1000;
      if (index >= 0) {
        this.$swal({
          position: "top-end",
          type: "success",
          title: "Modifiacation sauvegardé(s)",
          showConfirmButton: false,
          timer: 1500,
        });
      }
      location.href = "/operationV2/" + this.$route.params._id + "/counters";
    },
    previewForm(_id) {
      this.formId = _id;
      event.preventDefault();
      this.$refs.modal.open();
      return;
    },
    deleteCounter: async function(index) {
      if (!confirm("Voulez vous supprimer se compteur ?")) {
        return;
      }
      this.counters.splice(index, 1);
      this.saveCounter("suppr");
      this.$swal({
        position: "top-end",
        type: "success",
        title: "Compteur supprimé",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    async addCounter() {
      if (!this.newCounter.name || !this.newCounter.type) {
        alert(
          "Vous devez au minimum donner un nom à votre compteur et selectionner un type"
        );
        return;
      }
      if (this.newCounter.type === "LIMITATIVE" && !this.newCounter.limit) {
        alert("Veuillez renseigner une limite");
        return;
      }
      this.counters.push(this.newCounter);
      this.saveCounter();
      this.$swal({
        position: "top-end",
        type: "success",
        title: "Compteur ajouté avec succès",
        showConfirmButton: false,
        timer: 1500,
      });
      this.newCounter = {};
      // var response = await this.$axios
      //   .post("/api/v2/counters/" + this.$route.params._id,
      //     this.newCounter
      //   )
      // this.newCounter = []
      // this.counters = response.data
    },
    getCodePays({ name, label }) {
      return name;
    },
    getCodeStatus({ name, label }) {
      return label;
    },
    addLot() {
      this.emails.push({});
    },
    deleteLot(index) {
      Vue.delete(this.emails, index);
    },
    editTemplate(index, item) {
      event.preventDefault();
      this.emailcontent = this.emails[index].content;
      this.emailIndex = index;
      this.openmail = true;
      this.sujetEmail = item.sujet;
      this.templateID = item.templateID;

      setTimeout(() => {
        const placeholderPickerItems = Array.prototype.slice.call(
          document.querySelectorAll(".ql-placeholder .ql-picker-item")
        );
        placeholderPickerItems.forEach(
          (item) => (item.textContent = item.dataset.value)
        );
        document.querySelector(".ql-placeholder .ql-picker-label").innerHTML =
          "Insert tag" +
          document.querySelector(".ql-placeholder .ql-picker-label").innerHTML;
      }, 500);

      return;
    },
    async setToReglement(file) {
      var upload_uri = "/api/upload/upd/" + this.$route.params._id;
      var fileupdate = await this.$axios.post(upload_uri, {
        data: { filename: file },
      });
      this.files = fileupdate.data;
    },
    async confirmDeleteFile(file) {
      try {
        var upload_uri = "/api/upload/" + this.$route.params._id;
        var filedelete = await this.$axios.delete(upload_uri, {
          data: { filename: file },
        });
        var newFiles = this.files.filter(function(obj) {
          return obj.filename !== file;
        });
        this.files = newFiles;
        console.log(newFiles);
        if (filedelete.status == 200) {
          this.$swal({
            position: "top-end",
            type: "success",
            title: "Document supprimé avec succès",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      } catch (e) {}
    },
    async deleteFile(file) {
      var filtered_matching = this.files.filter((s) =>
        s.filename.includes(file)
      );
      if (filtered_matching) {
        console.log(filtered_matching[0].filename);

        this.$swal({
          title: "Souhaitez vous vraiment supprimer ce document ?",
          showCancelButton: true,
          confirmButtonText: "Oui",
          cancelButtonText: "Non",
        }).then((result) => {
          if (result.value) {
            this.confirmDeleteFile(filtered_matching[0].filename);
          }
        });
      }
    },
    FileConvertSize(aSize) {
      aSize = Math.abs(parseInt(aSize, 10));
      var def = [
        [1, "octets"],
        [1024, "ko"],
        [1024 * 1024, "Mo"],
        [1024 * 1024 * 1024, "Go"],
        [1024 * 1024 * 1024 * 1024, "To"],
      ];
      for (var i = 0; i < def.length; i++) {
        if (aSize < def[i][0])
          return (aSize / def[i - 1][0]).toFixed(2) + " " + def[i - 1][1];
      }
    },
    async handleFileUpload(name) {
      try {
        this.$swal({
          position: "top-end",
          title: "Upload en cours !",
          html: "Merci de bien vouloir patienter.",
          timer: 999999000,
          onBeforeOpen: () => {
            this.$swal.showLoading(0);
          },
          onClose: () => {
            clearInterval(0);
          },
        });
        if (name) {
          this.file = this.$refs[name].files[0];
        } else {
          this.file = this.$refs.file.files[0];
        }
        var size = this.FileConvertSize(this.file.size);
        var upload_uri = "/api/upload/" + this.$route.params._id;
        var imgB64 = await this.getBase64(this.file);
        if (!this.filename) {
          alert("please enter a filename");
        }
        let parts = this.file.name.split(".");
        var exts = parts[parts.length - 1];
        if (exts === "jpg") exts = "jpeg";
        let filename = this.filename + "." + exts;
        console.log(filename);
        let response = await this.$axios.post(upload_uri, {
          imgB64: imgB64,
          filename: filename,
          size: size,
          lastModified: new Date(),
          path: this.form.idgame,
        });
        var nwdate = new Date();
        if (this.files) {
          if (this.files.some((file) => file.filename === filename)) {
            this.files.find(
              (o) => o.filename === filename
            ).size = this.FileConvertSize(this.file.size);
            this.files.find((o) => o.filename === filename).date = nwdate;
          } else {
            this.files.push({
              filename: filename,
              uri: response.data.uri,
              date: nwdate,
              size: size,
            });
          }
        } else {
          this.files = [];
          this.files.push({
            filename: filename,
            uri: response.data.uri,
            date: nwdate,
            size: size,
          });
        }
        this.$swal({
          position: "top-end",
          type: "success",
          title: "Document sauvegardé avec succès",
          showConfirmButton: false,
          timer: 1500,
        });
        this.filename = undefined;
      } catch (e) {
        console.log(e);
      }
    },
    getBase64(file, onLoadCallback) {
      return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function() {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    nextStep(num) {
      this.$validator.validateAll().then(async (valid) => {
        if (num === 0) valid = true;
        if (valid) {
          this.form.lang = this.form.pays.name;
          if ((this.form.doublon = "OUI")) {
            this.form.doublon = true;
          } else {
            this.form.doublon = false;
          }
          if (this.odr_options.type) {
            var type_od = this.odr_options.type;
            var type_o = { type: this.odr_options.type };
            if (this.odr_options.datas[type_od].refund_eur)
              type_o.refund_eur = this.odr_options.datas[type_od].refund_eur;
            if (this.odr_options.datas[type_od].refund_percent)
              type_o.refund_percent = this.odr_options.datas[
                type_od
              ].refund_percent;
            if (this.odr_options.datas[type_od].max)
              type_o.max = this.odr_options.datas[type_od].max;
            if (this.odr_options.datas[type_od].gamme_A)
              type_o.gamme_A = this.odr_options.datas[type_od].gamme_A;
            if (this.odr_options.datas[type_od].gamme_B)
              type_o.gamme_B = this.odr_options.datas[type_od].gamme_B;
            if (this.odr_options.datas[type_od].refund_condition)
              type_o.refund_condition = this.odr_options.datas[
                type_od
              ].refund_eur;
            if (this.odr_options.datas[type_od].code_js)
              type_o.code_js = this.odr_options.datas[type_od].code_js;
            if (this.odr_options.datas[type_od].price_list)
              type_o.price_list = this.odr_options.datas[type_od].price_list;
            this.form.odr_options = type_o;
          }
          this.form.emailConfig = this.emailConfig;
          this.form.emails = this.emails;
          if (this.custom.typebackground === "image") {
            this.custom.body_background_color = "";
          } else if (this.custom.typebackground === "couleur") {
            // this.confirmDeleteFile("background_mb.jpg");
          } else {
            this.custom.body_background_color = "";
            // this.confirmDeleteFile("background_mb.jpg");
          }
          if (this.custom.banner_disable_animation === "false")
            this.custom.banner_disable_animation = "";
          this.custom.banner_disable_animation = Boolean(
            this.custom.banner_disable_animation
          );
          if (this.custom.banner_disable_cookie === "false")
            this.custom.banner_disable_cookie = "";
          this.custom.banner_disable_cookie = Boolean(
            this.custom.banner_disable_cookie
          );    
          // this.custom.links = this.clean(this.custom.links);
          this.form.custom = this.custom;
          this.form.creatorId = this.userinfos._id
          try {
            let result = await this.$axios.put(
              "/api/operations/update/" + this.$route.params._id,
              {
                ...this.form,
              }
            );
            if (result.data) {
              this.$swal({
                position: "top-end",
                type: "success",
                title: "Modifications sauvegardées",
                showConfirmButton: false,
                timer: 1500,
              });
            }
            this.checkDns();
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
    saveEmails() {
      this.emails[this.emailIndex].content = this.emailcontent;
      this.openmail = false;
      this.nextStep();
    },
    changeTemplate() {
      var email = this.emailList.filter((email) => {
        return email.type === this.emailType;
      });
      this.emailcontent = email[0].content;
    },
    async saveMention() {
      let result = await this.$axios.put(
        "/api/operations/update/" + this.$route.params._id,
        {
          mentionsLegales: this.form.mentionsLegales,
          contactezNous: this.form.contactezNous,
        }
      );
      this.$swal({
        position: "top-end",
        type: "success",
        title: "Modifications sauvegardées",
        showConfirmButton: false,
        timer: 1500,
      });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.ql-color .ql-picker-options [data-value="custom-color"] {
  background: none !important;
  width: 100% !important;
  height: 20px !important;
  text-align: center;
}
.ql-color .ql-picker-options [data-value="custom-color"]:before {
  content: "Custom Color";
}
.ql-color .ql-picker-options [data-value="custom-color"]:hover {
  border-color: transparent !important;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="0.8rem"]::before {
  content: "Small";
  font-size: 14px !important;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="1rem"]::before {
  content: "Normal";
  font-size: 16px !important;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="1.5rem"]::before {
  content: "Large";
  font-size: 22px !important;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="2rem"]::before {
  content: "Huge";
  font-size: 34px !important;
}

.uploader-file-name {
  text-align: left;
}
.uploader-btn {
  width: 30%;
  border-radius: 5px !important;
  background-color: #c8dad3 !important;
}
.uploader-drop {
  margin-top: 20px;
  margin-bottom: 20px;
  padding-bottom: 50px !important;
}
.files {
  display: flex;
  line-height: 35px;
}
.files div {
  width: 33%;
  text-align: left;
  border-bottom: dashed 1px gray;
}
.files div:nth-child(1) {
  width: 500px;
}
.upload-btn-wrapper,
.upload-btn-wrapper2 {
  position: relative;
  overflow: hidden;
  display: inline-block;
}
.btn {
  border: 2px solid gray;
  color: gray;
  background-color: white;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 20px;
  font-weight: bold;
}
.btn2 {
  color: #696774;
  background-color: white;
  padding: 8px 20px;
  font-size: 16px;
  font-weight: bold;
}
.upload-btn-wrapper input[type="file"],
.upload-btn-wrapper2 input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.datepicker {
  width: 300px;
  font-family: "PT Sans", sans-serif;
  input {
    font-family: "PT Sans", sans-serif;
    border-radius: 5px;
    border: none;
    width: 100%;
  }
}
.datepicker-popup {
  width: 300px !important;
  font-family: "PT Sans", sans-serif;
}
.calendar-head,
.calendar-body,
.calendar-foot {
  width: 300px;
  font-family: "PT Sans", sans-serif;
}
.button_wrap {
  display: block;
  width: 100%;
}

.headlogo {
  width: 100%;
  margin-top: -20px;
  text-align: center;
}

.ql-toolbar .ql-my-thing {
  width: 60px !important;
}
.ql-toolbar .ql-my-thing:before {
  content: "My Thing";
}
.my-thing {
  background: #f00;
  color: #fff;
}

.dnscheck {
  width: 100%;
  background: #eee;
  border-radius: 8px;
  padding: 10px;

  .warning {
    color: rgb(140, 110, 12)
  }
  .success {
    color: rgb(25, 156, 82)
  }
  .error {
    color: rgb(164, 28, 19)
  }
}
</style>
